/* eslint eqeqeq: "off" */
import React, { useEffect, useRef, useState } from "react";
import MetaTags from "react-meta-tags";
import {
  Col,
  Divider,
  Input,
  Select,
  Checkbox,
  // DatePicker,
  AutoComplete,
  Modal,
  Row,
  Tooltip,
  Typography,
  Switch,
  Button,
  Radio,
  Popover,
} from "antd";
import { toast, ToastContainer } from "react-toastify";
import DatePicker from "react-datepicker";
import {
  SettingOutlined,
  EditOutlined,
  DeleteOutlined,
  CloseCircleOutlined,
  ArrowLeftOutlined,
  PlusOutlined,
  ExclamationCircleOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import { useHistory } from "react-router-dom";
// import { Prompt, useHistory } from "react-router-dom";
import useBeforeUnload from "../../components/Prompting";
import "./index.css";
import { isEmpty, isUndefined } from "lodash";
import useMedia from "use-media-antd-query";
import { useDispatch, useSelector } from "react-redux";
import {
  loadExpensesCategories,
  loadExpensesItemList,
  loadExpensesList,
  loadExpensesListRecordsMetaData,
  loadPrefixSettingsList,
} from "../../store/expenses/actions";
import { loadParties } from "../../store/parties/actions";
import { BiCalendar } from "react-icons/bi";
import api from "../../helpers";
import moment from "moment";
import SimpleReactValidator from "simple-react-validator";
import { loadPartyAccountList } from "../../store/payment-in/actions";
import { loadItemsRecordsMetaData } from "../../store/items/actions";
import PropTypes from "prop-types";

const CreateExpenses = (props) => {
  const history = useHistory();
  const dispatch = useDispatch();
  const media = useMedia();

  // validations
  const simpleValidator = useRef(new SimpleReactValidator());
  const [, forceUpdate] = useState();

  //organisation id from login response
  const userName = localStorage.getItem("authData");

  const userNameDetails = JSON.parse(userName);

  const userInfoDetails = !isEmpty(userNameDetails)
    ? userNameDetails.user.organizations[0].organizationId
    : "";
  const userId = !isEmpty(userNameDetails) ? userNameDetails.user._id : "";

  const organizationId = !isEmpty(userInfoDetails) && userInfoDetails;

  const orgList = { organizationId: organizationId };

  //Reducer state
  const { recordsMetaData = {} } = useSelector((state) => state.Items);
  const {
    expenses_categories_list = [],
    expenses_item_list = [],
    expenseMetaData = {},
    prefix_settings_list = [],
  } = useSelector((state) => state.Expenses);
  const { parties_list = [] } = useSelector((state) => state.Parties);
  const { party_account_list = [] } = useSelector((state) => state.PaymentIn);

  //state initial
  const [purchaseMode, setPurchaseMode] = useState([]);
  const [paymentModeId, setPaymentModeId] = useState("");
  const [paymentMode, setPaymentMode] = useState([]);
  const [expenseDate, setExpenseDate] = useState("");

  // expenseMetaData &&
  // expenseMetaData.paymentModeOptions &&
  // expenseMetaData.paymentModeOptions.length > 0
  //   ? expenseMetaData.paymentModeOptions.find((data) => data.label === "Cash")
  //       .value
  //   : "";

  // const today = moment().format("DD-MM-YYYY");
  const today = new Date();
  today.setDate(today.getDate());
  // updated data from edit
  const updatedData =
    props.location && props.location.state
      ? props.location.state.expenseInvoiceData
      : "";
  const salesPrefixList = {
    organizationId: organizationId,
    isType: "isExpense",
  };

  //api loader
  useEffect(() => {
    const initialPaymentModeId = "66c9bd5ab3fca462ca48a87e";
    dispatch(loadParties(orgList));
    dispatch(loadExpensesCategories(orgList));
    dispatch(loadExpensesListRecordsMetaData());
    dispatch(loadItemsRecordsMetaData());
    setPurchaseMode("Without Tax");
    dispatch(loadPrefixSettingsList(salesPrefixList));
    setPaymentModeId(initialPaymentModeId);
    setPaymentMode("Cash");
    setExpenseDate(today);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //options list
  const partyOptions =
    parties_list && parties_list.length > 0
      ? parties_list.map((data) => {
          return { value: data._id, label: data.partyName };
        })
      : [];
  const categoryOptions =
    expenses_categories_list.length > 0
      ? expenses_categories_list.map((c) => {
          return {
            label: c.expenseName,
            value: c._id,
          };
        })
      : [];
  const partyAccountOptions =
    party_account_list && party_account_list.length > 0
      ? party_account_list.map((data) => {
          return {
            accountName: data.accountName,
            openingBalance: data.openingBalance,
            asOfDate: data.asOfDate,
            accountNumber: data.accountNumber,
            bankName: data.bankName,
            bankBranch: data.bankBranch,
            ifscCode: data.ifscCode,
            accountHolderName: data.accountHolderName,
            upiId: data.upiId,
            label:
              data.accountNumber == "" && !isEmpty(data.accountName) ? (
                <h1 className="text-[12px] text-[#4096ffba]">
                  {data.accountName}
                </h1>
              ) : !isEmpty(data.accountNumber) && !isEmpty(data.accountName) ? (
                <>
                  <h1 className="text-[12px]">{data.accountName}</h1>
                  <p className="text-[12px] text-[#4096ffba] mt-[-7px]">
                    {data.accountNumber}
                  </p>
                </>
              ) : (
                ""
              ),
            value: data._id,
          };
        })
      : [];
  // const partyAccountList =
  //   partyAccountOptions && partyAccountOptions.length > 0
  //     ? partyAccountOptions.filter(
  //         (data) => data.accountName !== ""
  //         // && data.accountNumber !== ""
  //       )
  //     : [];

  //expenses State values
  const [purchasePriceModal, setPurchasePriceModal] = useState(false);
  const [invoiceShow, setInvoiceShow] = useState(false);
  const [partiesList, setPartiesList] = useState([]);
  const [categories, setCategories] = useState([]);
  const [accountList, setAccountList] = useState([]);
  const [prefixValidations, setPrefixValidations] = useState(false);
  const [expenseData, setExpenseData] = useState({
    invoiceNumber: "",
    totalAmount: "",

    notes: "",
    expenseName: "",
    partyId: "",
    accountId: "",
    categoryId: "",
    _id: "",
  });

  const [expensePrefixData, setExpensePrefixData] = useState({
    expenseNumber: "",
    expensePrefix: "",
    seqNo: "",
    prefix: "",
  });

  const [expenseCategory, setExpenseCategory] = useState({
    _id: "",
    expenseName: "",
  });

  const handleExpensePrefixChange = (e) => {
    setExpensePrefixData({
      ...expensePrefixData,
      [e.target.name]: e.target.value,
    });
  };
  const handleExpenseCategoryChange = (e) => {
    setExpenseCategory({
      ...expenseCategory,
      [e.target.name]: e.target.value,
    });
  };
  const handleChange = (e) => {
    setExpenseData({
      ...expenseData,
      [e.target.name]: e.target.value,
    });
  };

  //Search parties end

  //Total section data
  const [additionalChargesOpen, setAdditionalChargesOpen] = useState(false);
  const [discountOpen, setDiscountOpen] = useState(false);
  const [pageRouting, setPageRouting] = useState(false);

  const [totalSectionData, setTotalSectionData] = useState({
    chargesData: "",
    additionalCharges: "",
    discountPercent: "",
    discountAmount: "",
    chargeId: "",
  });
  const [discountPercent, setDiscountPercent] = useState("");
  const [discountAmount, setDiscountAmount] = useState("");
  const [additionalOptions, setAdditionalOptions] = useState([]);

  const handleExpenseChange = (e) => {
    setTotalSectionData({
      ...totalSectionData,
      [e.target.name]: e.target.value,
    });
  };

  //Item states
  const [itemModal, setItemModal] = useState(false);
  const [deleteExpenseItem, setDeleteExpenseItem] = useState(false);
  const [createItemModal, setCreateItemModal] = useState(false);
  const [expenseWithGst, setExpenseWithGst] = useState(false);
  const [itemType, setItemType] = useState("");
  const [measuringUnit, setMeasuringUnit] = useState([]);
  const [gstRate, setGstRate] = useState([]);
  const [itcApplicable, setItcApplicable] = useState([]);
  const [newItemData, setNewItemData] = useState({
    itemName: "",
    purchasePrice: "",
    hsnCode: "",
    _id: "",
    gstRate: "",
    measuringUnit: "",
    itcApplicable: "",
  });

  const handleNewItemChange = (e) => {
    setNewItemData({
      ...newItemData,
      [e.target.name]: e.target.value,
    });
  };
  //CategoryModal
  const [addCategoryModal, setAddCategoryModal] = useState(false);
  const [newExpenseCategory, setNewExpenseCategory] = useState(false);
  const [deleteCategory, setDeleteCategory] = useState(false);
  const [newExpenseMode, setNewExpenseMode] = useState("");
  const [isCategoryButtonDisabled, setIsCategoryButtonDisabled] =
    useState(false);
  const [isDeleteButtonDisabled, setIsDeleteButtonDisabled] = useState(false);

  //cancel payment
  const cancelPaymentIn = () => {
    setPageRouting(true);
  };

  const addCategoryApi = () => {
    if (!isEmpty(expenseCategory.expenseName)) {
      setIsCategoryButtonDisabled(true);
      setTimeout(() => {
        setIsCategoryButtonDisabled(false);
      }, 6000);
      const categoryDetails = {
        organizationId: organizationId,
        expenseName: expenseCategory.expenseName,
        createdBy: userId,
      };

      api
        .post("/org/addexpensecategory", categoryDetails)
        .then((res) => {
          toast.success("Expense categories added successfully");
          setNewExpenseCategory(false);
          dispatch(
            loadExpensesCategories({
              organizationId: organizationId,
            })
          );
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message;
          toast.error(errorMsg || "An Error while adding the expense caegory");
          return Promise.reject(error);
        });
    } else {
      toast.error("The expense name field is required");
    }
  };

  const updateCategoryApi = () => {
    if (!isEmpty(expenseCategory.expenseName)) {
      setIsCategoryButtonDisabled(true);
      setTimeout(() => {
        setIsCategoryButtonDisabled(false);
      }, 6000);
      const categoryDetails = {
        organizationId: organizationId,
        expenseName: expenseCategory.expenseName,
        updatedBy: userId,
        expensecategoryId: expenseCategory._id,
      };

      api
        .put("/org/editexpensecategory", categoryDetails)
        .then((res) => {
          toast.success("Expense categories updated successfully");
          setNewExpenseCategory(false);
          dispatch(
            loadExpensesCategories({
              organizationId: organizationId,
            })
          );
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message;
          toast.error(
            errorMsg || "An Error while updating the expense caegory"
          );
          return Promise.reject(error);
        });
    } else {
      toast.error("The expense name field is required");
    }
  };

  const deleteCategoryApi = () => {
    setIsDeleteButtonDisabled(true);
    setTimeout(() => {
      setIsDeleteButtonDisabled(false);
    }, 6000);
    const categoryDetails = {
      organizationId: organizationId,
      expenseName: expenseCategory.expenseName,
      deletedBy: userId,
      expensecategoryId: expenseCategory._id,
    };

    api
      .post("/org/deleteexpensecategory", categoryDetails)
      .then((res) => {
        toast.error("Expense categories deleted successfully");
        setDeleteCategory(false);
        dispatch(
          loadExpensesCategories({
            organizationId: organizationId,
          })
        );
        return res.data;
      })
      .catch((error) => {
        const errorMsg =
          error &&
          error.response &&
          error.response.data &&
          error.response.data.message;
        toast.error(errorMsg || "An Error while deleting the expense caegory");
        return Promise.reject(error);
      });
  };

  //items
  const [renderPage, setRenderPage] = useState(false);
  const [pageRender, setPageRender] = useState(false);
  const [itemRows, setItemRows] = useState([
    {
      hsnCode: "",
      isProduct: "",
      isService: "",
      isWithTax: "",
      isWithoutTax: "",
      itemChecked: false,
      itemName: "",
      itemNameValue: "",
      quantityCount: 0,
      purchasePrice: "",
      purchasePriceValue: "",
      measuringUnitName: "",
      gstrateId: "",
      gstrateName: "",
      taxPercentage: "",
      taxValue: "",
      taxPercentageId: "",
      taxPercentageName: "",
      taxableAmount: "",
      taxPercentageValue: "",
      itcApplicableId: "",
      measuringUnitId: "",
      itcApplicableName: "",
      organizationId: "",
      _id: "",
    },
  ]);

  const [itemSelectedRows, setItemSelectedRows] = useState([
    {
      itemName: "",
      // itemChecked: "",
      itemNameValue: "",
      itemDescription: "",
      itemCode: "",
      isWithTax: "",
      isWithoutTax: "",
      measuringUnitName: "",
      gstrateId: "",
      itcApplicableId: "",
      measuringUnitId: "",
      gstrateName: "",
      itcApplicableName: "",
      salesPrice: "",
      purchasePrice: "",
      purchasePriceValue: "",
      discountPrice: "",
      discountPercentage: "",
      taxPercentage: "",
      taxValue: "",
      taxPercentageId: "",
      taxPercentageName: "",
      taxableAmount: "",
      taxPercentageValue: "",
      totalAmount: "",
      hsnCode: "",
      stockQTY: "",
      quantityCount: "",
      createdAt: "",
      createdBy: "",
      isProduct: "",
      isService: "",
      expenseitemId: "",
      qty: "",
      priceofItem: "",
      discountAmount: "",
      itemAmount: "",
      _id: "",
      index: "",
      action: "",
      status: "",
    },
  ]);

  const itemsDataTable =
    expenses_item_list && expenses_item_list.length > 0
      ? expenses_item_list.map((data, index) => {
          const gstPercentage =
            data.gstTaxRateName && data.gstTaxRateName.replace(/^%|%$/g, "");
          return {
            index: index + 1,
            hsnCode: data.hsnCode,
            isProduct: data.isProduct,
            isService: data.isService,
            isWithTax: data.isWithTax,
            isWithoutTax: data.isWithoutTax,
            itemName: data.itemName,
            itemChecked: data.itemChecked === true ? data.itemChecked : false,
            itemNameValue: data.itemName,
            purchasePrice: data.purchasePrice,
            purchasePriceValue: data.purchasePrice,
            createdAt: data.createdAt,
            gstrateId: data.gsttaxrateId,
            taxPercentage: "",
            taxValue: "",
            taxPercentageId: data.gsttaxrateId,
            taxPercentageName: data.gstTaxRateName,
            taxableAmount: "",
            taxPercentageValue: gstPercentage,
            itcStatusId: data.itcApplicableId,
            measuringUnitName: data.measuringUnitName,
            measuringUnitId: data.measuringUnitId,
            gstrateName: data.gstTaxRateName,
            quantityCount: 0,
            itcApplicableName: data.itcApplicableName,
            organizationId: data.organizationId,
            _id: data._id,
          };
        })
      : [];

  useEffect(() => {
    if (itemsDataTable && itemsDataTable.length > 0) {
      setItemRows(itemsDataTable);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [expenses_item_list]);
  // Handle quantity change (both increment and decrement)
  // const handleQuantityChange = (rowId, increment) => {
  //   setItemRows((prevRows) =>
  //     prevRows.map((row) =>
  //       row._id === rowId
  //         ? { ...row, quantityCount: row.quantityCount + increment }
  //         : row
  //     )
  //   );

  //   const updatedRow = itemRows.find((row) => row._id === rowId);
  //   // const alreadySent = itemSelectedRows.some((row) => row._id === rowId);

  //   setItemSelectedRows((prev)=> [...prev, updatedRow])
  //   // if (alreadySent && updatedRow) {
  //   //   sendQuantityUpdate(rowId, updatedRow.quantityCount + increment);
  //   // }
  // };

  //handle item rows change
  const handleItemChange = (e, name, index, data) => {
    const itemList = itemRows;
    if (name == "itemChecked") {
      itemList[index][name] = e.target.checked;
      itemList[index]["quantityCount"] = 1;
      setItemRows(itemList);
      setRenderPage(!renderPage);

      const selectedIndex = itemSelectedRows.indexOf(data);
      let newSelecteds = [];
      if (e.target.checked === true) {
        if (selectedIndex === -1) {
          newSelecteds = newSelecteds.concat(itemSelectedRows, data);
        }
      }
      //  else if(e.target.checked === false) {
      //   itemList[index]['quantityCount'] = 0;
      // }
      else {
        newSelecteds = newSelecteds.concat(itemSelectedRows.slice(0, -1));
      }

      if (e.target.checked === false) {
        itemList[index]["quantityCount"] = 0;
      }

      const itemSelectedFilteredRows =
        newSelecteds && newSelecteds.length > 0
          ? newSelecteds.filter((data) => !isEmpty(data.itemName))
          : [];

      const itemSelectedArrays =
        newSelecteds &&
        itemSelectedFilteredRows &&
        itemSelectedFilteredRows.length > 0
          ? itemSelectedFilteredRows.map((item) => {
              const gstRateName =
                item.taxPercentageValue !== undefined
                  ? item.taxPercentageValue
                  : item.taxPercentageName == "None" ||
                    item.taxPercentageName == "Exempted"
                  ? 0
                  : "";
              const quantityCount = item.quantityCount;
              const totalPriceData =
                !isUndefined(quantityCount) && item.purchasePrice
                  ? quantityCount * item.purchasePrice
                  : 0;

              const percentageValue = parseFloat(
                totalPriceData * item.taxPercentageValue
              );
              const gstInclusion =
                Number(100) + Number(item.taxPercentageValue);

              const taxPriceData =
                item.taxPercentageValue !== undefined &&
                item.isWithoutTax == true
                  ? parseFloat(percentageValue / 100)
                  : item.taxPercentageValue !== undefined &&
                    item.isWithTax == true
                  ? Number(percentageValue) / Number(gstInclusion).toFixed(2)
                  : "";
              const purchasePrice =
                item.isWithTax == true && expenseWithGst === true
                  ? parseFloat(
                      quantityCount * item.purchasePriceValue - taxPriceData
                    )
                  : item.isWithoutTax == true && expenseWithGst === true
                  ? item.purchasePrice
                  : item.purchasePrice;
              // const withTaxSetAmount =
              // purchasePrice +
              //     taxPriceData

              const totalSetAmountData =
                expenseWithGst == true &&
                taxPriceData !== undefined &&
                item.isWithoutTax == true
                  ? parseFloat(totalPriceData)
                  : expenseWithGst == true &&
                    item.isWithTax == true &&
                    taxPriceData !== undefined
                  ? Number(purchasePrice) + Number(taxPriceData)
                  : totalPriceData;
              const totalPrice = totalSetAmountData;

              return {
                // index: index + 1,
                itemName: item.itemName,
                itemNameValue: item.itemName,
                itemChecked: true,
                _id: item._id,
                itemCode: item.hsnCode ? item.hsnCode : "--",
                salesPrice: item.salesPrice ? item.salesPrice : "",
                purchasePrice: item.purchasePrice ? purchasePrice : "",
                createdAt: item.createdAt ? item.createdAt : "",
                createdBy: item.createdBy ? item.createdBy : "",
                categoryId: item.categoryId ? item.categoryId : "",
                categoryName: item.categoryName ? item.categoryName : "",
                categoryNameValue: item.categoryName ? item.categoryName : "",
                isWithoutTax: item.isWithoutTax ? item.isWithoutTax : "",
                isWithTax: item.isWithTax ? item.isWithTax : "",
                taxPercentageId: item.taxPercentageId
                  ? item.taxPercentageId
                  : "",
                taxPercentageName: item.taxPercentageName
                  ? item.taxPercentageName
                  : "",
                taxPercentage: item.taxPercentage ? item.taxPercentage : "",
                taxValue:
                  taxPriceData !== "" && expenseWithGst === true
                    ? taxPriceData
                    : item.taxValue
                    ? item.taxValue
                    : "",
                taxPercentageValue:
                  item.gstrateName !== undefined && expenseWithGst === true
                    ? gstRateName
                    : item.taxPercentageValue,
                itemCodeValue: item.hsnCode ? item.hsnCode : "",
                salesPriceValue: item.salesPrice ? item.salesPrice : "",
                purchasePriceValue: item.purchasePrice
                  ? item.purchasePrice
                  : "",
                discountPrice: !isUndefined(item.discountPrice)
                  ? item.discountPrice
                  : 0,
                discountPercentage: !isUndefined(item.discountPercentage)
                  ? item.discountPercentage
                  : 0,
                totalAmount: totalPrice,
                quantityCount: item.quantityCount ? item.quantityCount : "",
                categoryIdValue: item.categoryId ? item.categoryId : "",
                hsnCode: item.hsnCode ? item.hsnCode : "",
                // descriptionValue: item.description,
                isProduct: item.isProduct ? item.isProduct : "",
                isService: item.isService ? item.isService : "",
                measuringId: item.measuringId ? item.measuringId : "",
                description: item.description ? item.description : "",
                // serialDetails: item.serialDetails,
                updatedAt: item.updatedAt ? item.updatedAt : "",
                status: item.status ? item.status : "",
              };
            })
          : [];

      setItemSelectedRows(itemSelectedArrays);
    }
  };

  const removeItemsData = (index) => {
    // const array = itemSelectedRows;
    const array = [...itemSelectedRows];
    array.splice(index, 1); // Remove the row at the specified index
    setItemSelectedRows(array);
    setPageRender(!pageRender);
  };

  //item Selected on change
  const itemSelectedChange = (e, name, index) => {
    var itemList = itemSelectedRows;
    if (name == "itemDescription") {
      e = e.target.value;
      itemList[index][name] = e;
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "taxPercentageId") {
      const gstPercentageId =
        e &&
        recordsMetaData &&
        recordsMetaData.gstPercentageOptions.find((data) => data.value === e);
      const gstPercentage =
        gstPercentageId.label == "None" || gstPercentageId.label == "Exempted"
          ? 0
          : gstPercentageId.label.replace(/^%|%$/g, "");

      const totalAmount =
        !isUndefined(itemList[index].quantityCount) &&
        itemList[index].purchasePriceValue &&
        itemList[index].isWithTax == true
          ? parseFloat(
              itemList[index].quantityCount * itemList[index].purchasePriceValue
            )
          : isUndefined(itemList[index].quantityCount) &&
            itemList[index].purchasePriceValue &&
            itemList[index].isWithTax == true
          ? itemList[index].purchasePriceValue
          : isEmpty(itemList[index].purchasePriceValue) &&
            itemList[index].quantityCount &&
            itemList[index].isWithTax == true
          ? itemList[index].quantityCount
          : !isUndefined(itemList[index].quantityCount) &&
            itemList[index].purchasePrice
          ? parseFloat(
              itemList[index].quantityCount * itemList[index].purchasePrice
            )
          : isUndefined(itemList[index].quantityCount) &&
            itemList[index].purchasePrice
          ? itemList[index].purchasePrice
          : isEmpty(itemList[index].purchasePrice) &&
            itemList[index].quantityCount
          ? itemList[index].quantityCount
          : 0;
      const percentageValue = parseFloat(totalAmount * gstPercentage);
      const gstInclusion = Number(100) + Number(gstPercentage);
      const totalSetAmountData =
        itemList[index].isWithTax == true
          ? Number(percentageValue) / Number(gstInclusion)
          : parseFloat(percentageValue / 100);

      const purchasePrice =
        itemList[index].isWithTax == true &&
        (itemList[index].quantityCount !== undefined ||
          itemList[index].quantityCount !== "")
          ? parseFloat(
              itemList[index].purchasePriceValue -
                totalSetAmountData / itemList[index].quantityCount
            )
          : itemList[index].isWithTax == true
          ? parseFloat(itemList[index].purchasePriceValue - totalSetAmountData)
          : itemList[index].purchasePrice;
      console.log(purchasePrice, "purchasePrice tax");
      console.log(itemList, "itemList tax");
      const totalSetAmount =
        itemList[index].isWithTax == true
          ? parseFloat(totalAmount)
          : parseFloat(totalSetAmountData + totalAmount);
      const totalSetAmountTotal =
        // itemList[index].isWithTax == true && updatedData !== undefined && itemList[index].discountPrice
        //   ? totalSetAmount
        //   :
        itemList[index].discountPrice
          ? totalSetAmount - itemList[index].discountPrice
          : totalSetAmount;
      const discountAmountDetails = itemList[index].discountPrice;
      console.log(totalSetAmountData, "totalSetAmountData");
      console.log(totalSetAmount, "totalSetAmount");
      console.log(discountAmountDetails, "discountAmountDetails");
      console.log(totalSetAmountTotal, "totalSetAmountTotal");
      const withTax = itemList[index].isWithTax;
      const withoutTax =
        itemList[index].isWithTax == true
          ? false
          : itemList[index].isWithoutTax;

      console.log(withTax, "withTax");

      const purchasePriceValue = itemList[index].purchasePriceValue;

      itemList[index]["isWithTax"] = withTax;
      itemList[index]["isWithoutTax"] = withoutTax;
      itemList[index]["purchasePrice"] =
        purchasePrice && parseFloat(purchasePrice).toFixed(2);
      itemList[index]["purchasePriceValue"] = purchasePriceValue;
      itemList[index]["taxPercentageId"] = e;
      itemList[index]["taxPercentageName"] = gstPercentage;
      itemList[index]["taxPercentageValue"] = gstPercentage;
      itemList[index]["taxValue"] = totalSetAmountData;
      itemList[index]["totalAmount"] = totalSetAmountTotal.toFixed(2);
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
      // setPageRender(!pageRender);
    }
    if (name == "purchasePrice") {
      e = e.target.value;
      const totalAmountData =
        !isUndefined(itemList[index].quantityCount) && e
          ? parseFloat(itemList[index].quantityCount * e)
          : isUndefined(itemList[index].quantityCount) && e
          ? e
          : isEmpty(e) && itemList[index].quantityCount
          ? itemList[index].quantityCount
          : 0;

      const discountPrice =
        itemList[index].discountPrice &&
        parseInt(itemList[index].discountPrice) > 0
          ? (e * totalAmountData) / 100
          : 0;
      const discountPercentage =
        itemList[index].discountPercentage &&
        parseInt(itemList[index].discountPercentage)
          ? (e * 100) / totalAmountData
          : 0;

      const totalAmountPrice =
        itemList[index].discountPrice &&
        parseInt(itemList[index].discountPrice) > 0
          ? parseInt(totalAmountData - discountPrice)
          : parseInt(totalAmountData);
      const percentageValue = parseFloat(
        totalAmountData * itemList[index].taxPercentageValue
      );
      const gstInclusion =
        Number(100) + Number(itemList[index].taxPercentageValue);
      const totalSetAmountData =
        itemList[index].isWithTax == true
          ? parseFloat(percentageValue / gstInclusion)
          : parseFloat(percentageValue / 100);

      // const totalSetAmountData =
      //   (parseInt(itemList[index].taxPercentageValue) * totalAmountData) / 100;

      const totalAmountDetails =
        itemList[index].isWithTax == true && totalSetAmountData
          ? parseFloat(totalAmountData + totalSetAmountData)
          : itemList[index].isWithoutTax == true && totalSetAmountData
          ? parseFloat(totalSetAmountData + totalAmountData)
          : totalAmountPrice;

      const withTax = itemList[index].isWithTax;
      const withoutTax =
        itemList[index].isWithTax == true
          ? false
          : itemList[index].isWithoutTax;
      // const purchasePrice = itemList[index].isWithTax == true ? parseFloat(e - totalSetAmountData) : e
      itemList[index][name] = e;
      itemList[index]["purchasePriceValue"] = e;
      itemList[index]["isWithTax"] = withTax;
      itemList[index]["isWithoutTax"] = withoutTax;
      itemList[index]["discountPercentage"] = discountPercentage;
      itemList[index]["discountPrice"] = discountPrice;
      itemList[index]["totalAmount"] = totalAmountDetails && parseFloat(totalAmountDetails).toFixed(2)
      itemList[index]["taxValue"] = totalSetAmountData;
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "quantityCount") {
      console.log(itemList, "itemList");
      e = e.target.value;
      const totalAmountData =
        !isUndefined(e) &&
        itemList[index].purchasePriceValue &&
        itemList[index].isWithTax == true
          ? parseFloat(e * itemList[index].purchasePriceValue)
          : isUndefined(e) &&
            itemList[index].purchasePriceValue &&
            itemList[index].isWithTax == true
          ? itemList[index].purchasePriceValue
          : isEmpty(itemList[index].purchasePriceValue) &&
            e &&
            itemList[index].isWithTax == true
          ? e
          : !isUndefined(e) && itemList[index].purchasePrice
          ? e * itemList[index].purchasePrice
          : isUndefined(e) && itemList[index].purchasePrice
          ? itemList[index].purchasePrice
          : isEmpty(itemList[index].purchasePrice) && e
          ? e
          : 0;
      console.log(totalAmountData, "totalAmountData");
      // const totalSetAmountData = parseInt(itemList[index].taxPercentageValue);
      const percentageValue = parseFloat(
        totalAmountData * itemList[index].taxPercentageValue
      );
      const gstInclusion =
        Number(100) + Number(itemList[index].taxPercentageValue);
      const totalSetAmountData =
        itemList[index].isWithTax == true
          ? Number(percentageValue) / Number(gstInclusion)
          : parseFloat(percentageValue / 100);
      console.log(totalSetAmountData, "totalSetAmountData");
      console.log(percentageValue, "percentageValue");
      // console.log(gstInclusion, "gstInclusion")
      // const totalSetAmountData =
      //   (parseInt(itemList[index].taxPercentageValue) * totalAmountData) / 100;
      const purchasePrice =
        itemList[index].isWithTax == true && e !== ""
          ? parseFloat(
              itemList[index].purchasePriceValue - totalSetAmountData / e
            )
          : itemList[index].purchasePrice;
      const totalAmountDetails =
        itemList[index].isWithTax == true && totalSetAmountData
          ? parseFloat(totalAmountData)
          : itemList[index].isWithoutTax == true && totalSetAmountData
          ? parseFloat(totalSetAmountData + totalAmountData)
          : totalAmountData;
      console.log(purchasePrice, "purchasePrice");
      // const purchasePrice = itemList[index].purchasePrice;
      const withTax = itemList[index].isWithTax;
      const withoutTax =
        itemList[index].isWithTax == true
          ? false
          : itemList[index].isWithoutTax;

      itemList[index][name] = e;
      itemList[index]["isWithTax"] = withTax;
      itemList[index]["isWithoutTax"] = withoutTax;
      itemList[index]["purchasePrice"] =
        purchasePrice && parseFloat(purchasePrice).toFixed(2);
      itemList[index]["totalAmount"] = totalAmountDetails && parseFloat(totalAmountDetails).toFixed(2);
      itemList[index]["taxValue"] = totalSetAmountData;
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "discountPercentage") {
      e = e.target.value;
      const totalAmountData =
        !isUndefined(itemList[index].quantityCount) &&
        itemList[index].purchasePrice
          ? itemList[index].quantityCount * itemList[index].purchasePrice
          : isUndefined(itemList[index].quantityCount) &&
            itemList[index].purchasePrice
          ? itemList[index].purchasePrice
          : isEmpty(itemList[index].purchasePrice) &&
            itemList[index].quantityCount
          ? itemList[index].quantityCount
          : 0;

      const discountPriceData = (e * totalAmountData) / 100;
      const totalAmountTax = parseFloat(
        totalAmountData + itemList[index].taxValue
      );

      const discountPrice = parseFloat(discountPriceData).toFixed(2);

      console.log(discountPrice, "discountPrice");

      const totalAmount = itemList[index].taxValue
        ? totalAmountTax - discountPriceData
        : totalAmountData - discountPriceData;

      console.log(totalAmount, "totalAmount");

      itemList[index][name] = e;
      itemList[index]["discountPrice"] =
        discountPrice && parseFloat(discountPrice);
      itemList[index]["totalAmount"] =
        totalAmount && parseFloat(totalAmount).toFixed(2);
      // itemList[index]["taxValue"] = discountTaxValue;
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "discountPrice") {
      e = e.target.value;
      const totalAmountData =
        !isUndefined(itemList[index].quantityCount) &&
        itemList[index].purchasePrice
          ? itemList[index].quantityCount * itemList[index].purchasePrice
          : isUndefined(itemList[index].quantityCount) &&
            itemList[index].purchasePrice
          ? itemList[index].purchasePrice
          : isEmpty(itemList[index].purchasePrice) &&
            itemList[index].quantityCount
          ? itemList[index].quantityCount
          : 0;
      const discountPercentage = (e * 100) / itemList[index].totalAmount;

      const discountPrice = totalAmountData - e;
      // const discountPriceValue = parseInt(itemList[index].discountPrice);

      const taxValue = parseInt(itemList[index].taxPercentageValue);
      const taxValueFinal =
        e > 0
          ? (discountPrice * taxValue) / 100
          : (totalAmountData * taxValue) / 100;

      // const totalAmount = e > 0 ? discountPrice : totalAmountData;

      const discountTaxValue =
        e > 0 ? taxValueFinal + discountPrice : totalAmountData + taxValueFinal;

      itemList[index][name] = e;
      itemList[index]["discountPercentage"] = discountPercentage;
      itemList[index]["totalAmount"] = discountTaxValue && parseFloat(discountTaxValue).toFixed(2);
      itemList[index]["taxValue"] = e == 0 || !isEmpty(e) ? taxValueFinal : "";
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
    if (name == "totalAmount") {
      e = e.target.value;
      itemList[index][name] = e;
      // itemList[index][name] = e
      setItemSelectedRows(itemList);
      setRenderPage(!renderPage);
    }
  };

  const [itemSearch, setItemSearch] = useState("");
  const [createItemValidations, setCreateItemValidations] = useState(false);

  const handleItemSearch = (event) => {
    const filteredRows = itemsDataTable
      .filter((row) =>
        row.itemNameValue
          .toLowerCase()
          .includes(event.target.value.toLowerCase())
      )
      .filter((item, index, self) => self.indexOf(item) === index); // Remove duplicates

    setItemSearch(event.target.value);
    setItemRows(filteredRows);
  };

  //Calculate totals
  const calculateTotals = (rows) => {
    let purchasePrice = 0;
    let discountPrice = 0;
    let totalAmount = 0;
    let taxValue = 0;

    rows.forEach((row) => {
      purchasePrice += parseFloat(row.purchasePrice * row.quantityCount) || 0;
      discountPrice += parseFloat(row.discountPrice) || 0;
      totalAmount += parseFloat(row.totalAmount) || 0;
      taxValue += parseFloat(rows.taxValue) || 0;
    });

    return { purchasePrice, discountPrice, totalAmount, taxValue };
  };

  const [totals, setTotals] = React.useState({
    purchasePrice: 0,
    discountPrice: 0,
    totalAmount: 0,
    taxValue: 0,
  });

  const additionalChargesFinalValues = totalSectionData.additionalCharges
    ? parseFloat(totalSectionData.additionalCharges)
    : "";
  const dicountAmountValues = discountAmount ? parseFloat(discountAmount) : "";

  //Po net amount
  const discountFinalAmount = parseFloat(
    totals.totalAmount + additionalChargesFinalValues
  );
  // const finalTotal = parseFloat(totals.totalAmount);

  const taxableTotalList =
    itemSelectedRows && itemSelectedRows.length > 0
      ? itemSelectedRows.map((data) => data.taxValue)
      : [];

  const taxableAmount =
    taxableTotalList && taxableTotalList.length > 0
      ? taxableTotalList.reduce((a, b) => {
          if (!isEmpty(a) && isEmpty(b)) {
            return parseFloat(a);
          } else if (isEmpty(a) && !isEmpty(b)) {
            return parseFloat(b);
          } else {
            return parseFloat(a + b);
          }
        })
      : updatedData && updatedData.itemsTotalTax
      ? updatedData.itemsTotalTax
      : "";

  const netAmountTotal =
    itemSelectedRows &&
    itemSelectedRows.length > 0 &&
    totalSectionData.additionalCharges == "" &&
    discountAmount == ""
      ? parseFloat(totals.totalAmount)
      : (itemSelectedRows.length > 0 &&
          totalSectionData.additionalCharges !== "" &&
          discountAmount !== "") ||
        discountPercent !== ""
      ? parseFloat(discountFinalAmount - dicountAmountValues)
      : itemSelectedRows.length > 0 &&
        totalSectionData.additionalCharges !== "" &&
        discountAmount == ""
      ? parseFloat(totals.totalAmount + additionalChargesFinalValues)
      : (itemSelectedRows.length > 0 &&
          totalSectionData.additionalCharges == "" &&
          discountAmount !== "") ||
        discountPercent !== ""
      ? parseFloat(totals.totalAmount - dicountAmountValues)
      : 0;

  const netAmount =
    // itemSelectedRows &&
    // itemSelectedRows.length > 0 &&
    // taxableAmount &&
    // updatedData
    //   ? parseInt(netAmountTotal + taxableAmount)
    //   :
    itemSelectedRows && itemSelectedRows.length > 0 && taxableAmount
      ? parseInt(netAmountTotal)
      : // ? parseInt(taxableAmount + netAmountTotal)
        netAmountTotal;

  useEffect(() => {
    const newTotals = calculateTotals(itemSelectedRows);
    setTotals(newTotals);
    setExpenseData({
      ...expenseData,
      totalAmount: newTotals.totalAmount,
    });
    //eslint-disable-next-line react-hooks/exhaustive-deps
  }, [itemSelectedRows, renderPage, pageRender]);

  const categoryDetails = {
    organizationId: organizationId,
    itemName: newItemData.itemName,
    isProduct: itemType === "Product" ? true : false,
    isService: itemType === "Service" ? true : false,
    purchasePrice: newItemData.purchasePrice,
    isWithTax: purchaseMode === "With Tax" ? true : false,
    isWithoutTax: purchaseMode === "Without Tax" ? true : false,
    hsnCode: newItemData.hsnCode,
    measuringUnitId:
      !isEmpty(measuringUnit) ||
      (measuringUnit !== undefined && measuringUnit.length > 0)
        ? measuringUnit
        : "",
    gsttaxrateId: purchaseMode === "With Tax" && gstRate ? gstRate.value : "",
    itcApplicableId:
      !isEmpty(itcApplicable) ||
      (itcApplicable !== undefined && itcApplicable.length > 0)
        ? itcApplicable
        : "",
    // expenseItemId: newItemData._id,
  };

  const categoryObj = Object.keys(categoryDetails).forEach(
    (key) =>
      (categoryDetails[key] == undefined || categoryDetails[key] === "") &&
      delete categoryDetails[key]
  );

  const categoryUpdateDetails = {
    organizationId: organizationId,
    itemName: newItemData.itemName,
    isProduct: itemType === "Product" ? true : false,
    isService: itemType === "Service" ? true : false,
    purchasePrice: newItemData.purchasePrice,
    isWithTax: purchaseMode === "With Tax" ? true : false,
    isWithoutTax: purchaseMode === "Without Tax" ? true : false,
    hsnCode: newItemData.hsnCode,
    measuringUnitId: !isEmpty(newItemData.measuringUnit)
      ? newItemData.measuringUnit
      : !isEmpty(measuringUnit) ||
        (measuringUnit !== undefined && measuringUnit.length > 0)
      ? measuringUnit
      : "",
    gsttaxrateId: purchaseMode === "With Tax" && gstRate ? gstRate.value : "",
    itcApplicableId: !isEmpty(newItemData.itcApplicable)
      ? newItemData.itcApplicable
      : !isEmpty(itcApplicable) ||
        (itcApplicable !== undefined && itcApplicable.length > 0)
      ? itcApplicable
      : "",
    expenseItemId: newItemData._id,
  };

  const categoryUpdateObj = Object.keys(categoryUpdateDetails).forEach(
    (key) =>
      (categoryUpdateDetails[key] == undefined ||
        categoryUpdateDetails[key] === "") &&
      delete categoryUpdateDetails[key]
  );

  console.log(itemSelectedRows, "itemSelectedRows");
  console.log(categoryUpdateObj, "categoryUpdateObj");
  console.log(categoryObj, "categoryObj");
  const [isExpenseButtonDisabled, setIsExpenseButtonDisabled] = useState(false);
  const createExpenseItemApi = () => {
    if (purchaseMode === "With Tax") {
      if (
        !isEmpty(newItemData.itemName) &&
        !isEmpty(itemType) &&
        !isEmpty(gstRate)
      ) {
        setIsExpenseButtonDisabled(true);
        setTimeout(() => {
          setIsExpenseButtonDisabled(false);
        }, 7000);
        api
          .post("/org/addexpenseitem", categoryDetails)
          .then((res) => {
            toast.success("Expense item added successfully");
            setCreateItemModal(false);
            dispatch(
              loadExpensesItemList({
                organizationId: organizationId,
              })
            );
            return res.data;
          })
          .catch((error) => {
            const errorMsg =
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.message) ||
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.error);
            toast.error(
              errorMsg &&
                purchaseMode == "With Tax" &&
                (gstRate === "" || gstRate.length == 0)
                ? errorMsg + ", Gst type field is required"
                : "" || "An Error while adding the expense items"
            );
            return Promise.reject(error);
          });
      } else {
        // toast.error("The expense name field is required");
        setCreateItemValidations(true);
        setCreateItemModal(true);
      }
    } else {
      if (!isEmpty(newItemData.itemName) && !isEmpty(itemType)) {
        setIsExpenseButtonDisabled(true);
        setTimeout(() => {
          setIsExpenseButtonDisabled(false);
        }, 7000);
        api
          .post("/org/addexpenseitem", categoryDetails)
          .then((res) => {
            toast.success("Expense item added successfully");
            setCreateItemModal(false);
            dispatch(
              loadExpensesItemList({
                organizationId: organizationId,
              })
            );
            return res.data;
          })
          .catch((error) => {
            const errorMsg =
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.message) ||
              (error &&
                error.response &&
                error.response.data &&
                error.response.data.error);
            toast.error(
              errorMsg &&
                purchaseMode == "With Tax" &&
                (gstRate === "" || gstRate.length == 0)
                ? errorMsg + ", Gst type field is required"
                : "" || "An Error while adding the expense items"
            );
            return Promise.reject(error);
          });
      } else {
        // toast.error("The expense name field is required");
        setCreateItemValidations(true);
        setCreateItemModal(true);
      }
    }
  };

  const updateExpenseItemApi = () => {
    if (!isEmpty(newItemData.itemName) && !isEmpty(itemType)) {
      console.log("withTax");
      setIsExpenseButtonDisabled(true);
      setTimeout(() => {
        setIsExpenseButtonDisabled(false);
      }, 7000);
      api
        .put("/org/updateexpenseitem", categoryUpdateDetails)
        .then((res) => {
          toast.success("Expense item updated successfully");
          setCreateItemModal(false);
          dispatch(
            loadExpensesItemList({
              organizationId: organizationId,
            })
          );
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message);
          toast.error(
            errorMsg &&
              purchaseMode == "With Tax" &&
              (gstRate === "" || gstRate.length == 0)
              ? errorMsg + ", Gst type field is required"
              : "" || "An Error while update the expense items"
          );
          return Promise.reject(error);
        });
    } else {
      // toast.error("The expense name field is required");
      setCreateItemValidations(true);
      setCreateItemModal(true);
    }
  };

  const deleteExpenseItemApi = () => {
    const categoryDetails = {
      organizationId: organizationId,
      expenseItemId: newItemData._id,
      deletedBy: userId,
    };
    setIsExpenseButtonDisabled(true);
    setTimeout(() => {
      setIsExpenseButtonDisabled(false);
    }, 7000);
    api
      .post("/org/deleteexpenseitem", categoryDetails)
      .then((res) => {
        toast.error("Expense item deleted successfully");
        setDeleteExpenseItem(false);
        dispatch(
          loadExpensesItemList({
            organizationId: organizationId,
          })
        );
        return res.data;
      })
      .catch((error) => {
        const errorMsg =
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.error) ||
          (error &&
            error.response &&
            error.response.data &&
            error.response.data.message);
        toast.error(errorMsg || "An Error while adding the expense items");
        return Promise.reject(error);
      });
  };

  // create expenses
  const expensesList = {
    organizationId: organizationId,
    isexpenseWithGST: expenseWithGst === false ? false : true,
    partyId:
      // (expenseWithGst === true && !isEmpty(partiesList)) ||
      // (expenseWithGst === true && partiesList.length > 0)
      !isEmpty(partiesList) || partiesList.length > 0 ? partiesList : "",
    // "vendorId": "66c72642304685bf3aefee40",
    categoryId: categories,
    expenseNo: expensePrefixData.expenseNumber,
    orginalInvoiceNo: expenseData.invoiceNumber,
    expenseDate: expenseDate ? moment(expenseDate).format("YYYY-MM-DD") : "",
    paymentModeId: paymentMode == "Cash" ? paymentModeId : paymentMode,
    isType:
      prefix_settings_list && prefix_settings_list.isEnable == true
        ? "isExpense"
        : "",
    // if bank means add accountId
    accountId:
      paymentMode === "Cash" || paymentMode === "66c9bd5ab3fca462ca48a87e"
        ? ""
        : accountList.length == 0
        ? ""
        : accountList,
    notes: expenseData.notes,
    expenseItem:
      itemSelectedRows &&
      itemSelectedRows.length > 0 &&
      itemSelectedRows[0]._id &&
      expenseWithGst === true
        ? itemSelectedRows.map((data) => {
            return {
              expenseitemId: data._id,
              hsnCode: data.hsnCode,
              qty: data.quantityCount,
              priceofItem: data.purchasePrice,
              discountAmount: data.discountPrice,
              discountPercentage:
                data.discountPercentage && parseFloat(data.discountPercentage),
              isWithTax:
                data.isWithTax == true
                  ? true
                  : data.isWithTax == ""
                  ? false
                  : false,
              isWithoutTax:
                data.isWithoutTax == true
                  ? true
                  : data.isWithoutTax == ""
                  ? false
                  : false,
              taxableAmount:
                data.taxValue && parseFloat(data.taxValue).toFixed(2),
              taxablePercentage: data.taxPercentageValue,
              itemAmount: data.itemAmount,
            };
          })
        : itemSelectedRows &&
          itemSelectedRows.length > 0 &&
          itemSelectedRows[0]._id &&
          expenseWithGst === false
        ? itemSelectedRows.map((data) => {
            return {
              expenseitemId: data._id,
              qty: data.quantityCount,
              priceofItem: data.purchasePrice,
              itemAmount: data.itemAmount,
            };
          })
        : expenseWithGst === false &&
          itemSelectedRows &&
          itemSelectedRows.length > 0 &&
          isEmpty(itemSelectedRows[0]._id)
        ? ""
        : [],
    itemsTotalAmount: totals.purchasePrice,
    itemsTotalDiscount: totals.discountPrice,
    itemsTotalTax: taxableAmount,
    additionalCharges:
      expenseWithGst === true && !isEmpty(totalSectionData.additionalCharges)
        ? [
            {
              chargeAmount: totalSectionData.additionalCharges,
              chargeName: totalSectionData.chargesData,
            },
          ]
        : "",
    taxableAmount: expenseWithGst === false ? "" : taxableAmount,
    discountAmount:
      expenseWithGst === false
        ? ""
        : discountAmount && parseFloat(discountAmount),
    discountPercentage:
      expenseWithGst === false
        ? ""
        : discountPercent && parseFloat(discountPercent),
    totalAmount:
      expenseWithGst === false &&
      itemSelectedRows &&
      itemSelectedRows.length > 0 &&
      isEmpty(itemSelectedRows[0]._id)
        ? parseInt(expenseData.totalAmount)
        : (expenseWithGst === false || expenseWithGst === true) &&
          itemSelectedRows &&
          itemSelectedRows.length > 0 &&
          !isEmpty(itemSelectedRows[0]._id)
        ? totals.totalAmount
        : parseInt(expenseData.totalAmount),
    createdBy: userId,
  };

  const expensesListObj = Object.keys(expensesList).forEach(
    (key) =>
      (expensesList[key] == undefined || expensesList[key] === "") &&
      delete expensesList[key]
  );

  console.log(expensesListObj, "expensesListObj");
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);
  const createExpensesApi = () => {
    if (
      simpleValidator.current.allValid()
      //  &&
      // itemSelectedRows.length > 0 &&
      // itemSelectedRows[0].itemName
    ) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 5000);
      api
        .post("/org/addexpense", expensesList)
        .then((res) => {
          toast.success("Expenses added successfully");
          dispatch(loadExpensesList(orgList));
          setTimeout(() => {
            history.push("/expenses");
          }, 500);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message;
          toast.error(errorMsg || "An Error while adding the expenses");
          return Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      if (itemSelectedRows.length >= 0 && itemSelectedRows[0].itemName == "") {
        toast.error("Expense Item fields are required");
      }
    }
  };

  // create expenses
  const expensesUpdatedList = {
    expenseId: expenseData._id,
    organizationId: organizationId,
    isexpenseWithGST: expenseWithGst === false ? false : true,
    partyId: !isEmpty(expenseData.partyId)
      ? expenseData.partyId
      : !isEmpty(partiesList) || partiesList.length > 0
      ? partiesList
      : // !isEmpty(expenseData.partyId) && expenseWithGst === true
        //   ? expenseData.partyId
        //   : (expenseWithGst === true && !isEmpty(partiesList)) ||
        //     (expenseWithGst === true && partiesList.length > 0)
        //   ? partiesList
        "",
    categoryId: !isEmpty(expenseData.categoryId)
      ? expenseData.categoryId
      : !isEmpty(categories) || categories.length > 0
      ? categories
      : "",
    isType:
      prefix_settings_list && prefix_settings_list.isEnable == true
        ? "isExpense"
        : "",
    expenseNo: expensePrefixData.expenseNumber,
    orginalInvoiceNo: expenseData.invoiceNumber,
    expenseDate: expenseDate ? moment(expenseDate).format("YYYY-MM-DD") : "",
    paymentModeId: paymentMode == "Cash" ? paymentModeId : paymentMode,
    // if bank means add accountId
    accountId: !isEmpty(expenseData.accountId)
      ? expenseData.accountId
      : paymentModeId === "66c9bd5ab3fca462ca48a87e" ||
        paymentMode === "66c9bd5ab3fca462ca48a87e"
      ? ""
      : accountList.length == 0
      ? ""
      : accountList,
    accountList,
    notes: expenseData.notes,
    expenseItem:
      itemSelectedRows &&
      itemSelectedRows.length > 0 &&
      itemSelectedRows[0].itemName &&
      expenseWithGst === true
        ? itemSelectedRows.map((data) => {
            return {
              expenseitemId: data._id
                ? data._id
                : data.expenseitemId
                ? data.expenseitemId
                : data._id,
              expenseitemName: data.itemName,
              hsnCode: data.hsnCode,
              qty: data.quantityCount,
              priceofItem: data.purchasePrice,
              isWithTax:
                data.isWithTax == true
                  ? true
                  : data.isWithTax == ""
                  ? false
                  : false,
              isWithoutTax:
                data.isWithoutTax == true
                  ? true
                  : data.isWithoutTax == ""
                  ? false
                  : false,
              discountAmount: data.discountPrice,
              discountPercentage: data.discountPercentage,
              taxableAmount: data.taxValue,
              taxablePercentage: data.taxPercentageValue,
              itemAmount: data.itemAmount,
            };
          })
        : itemSelectedRows &&
          itemSelectedRows.length > 0 &&
          itemSelectedRows[0].itemName &&
          expenseWithGst === false
        ? itemSelectedRows.map((data) => {
            return {
              expenseitemId: data._id
                ? data._id
                : data.expenseitemId
                ? data.expenseitemId
                : data._id,
              expenseitemName: data.itemName,
              qty: data.quantityCount,
              priceofItem: data.purchasePrice,
              itemAmount: data.itemAmount,
            };
          })
        : expenseWithGst === false &&
          itemSelectedRows &&
          itemSelectedRows.length > 0 &&
          isEmpty(itemSelectedRows[0].itemName)
        ? ""
        : [],
    itemsTotalAmount: totals.purchasePrice,
    itemsTotalDiscount: totals.discountPrice,
    itemsTotalTax: taxableAmount,
    additionalCharges:
      expenseWithGst === true &&
      !isEmpty(totalSectionData.additionalCharges) &&
      totalSectionData.chargeId == ""
        ? [
            {
              chargeAmount: totalSectionData.additionalCharges,
              chargeName: totalSectionData.chargesData,
            },
          ]
        : expenseWithGst === true &&
          !isEmpty(totalSectionData.additionalCharges) &&
          totalSectionData.chargeId !== ""
        ? [
            {
              chargeAmount: totalSectionData.additionalCharges,
              chargeName: totalSectionData.chargesData,
              _id: totalSectionData.chargeId,
            },
          ]
        : "",
    taxableAmount: expenseWithGst === false ? "" : taxableAmount,
    discountAmount: expenseWithGst === false ? "" : parseFloat(discountAmount),
    discountPercentage:
      expenseWithGst === false ? "" : totalSectionData.discountPercent,
    totalAmount:
      expenseWithGst === false &&
      itemSelectedRows &&
      itemSelectedRows.length > 0 &&
      isEmpty(itemSelectedRows[0]._id)
        ? parseInt(expenseData.totalAmount)
        : (expenseWithGst === false || expenseWithGst === true) &&
          itemSelectedRows &&
          itemSelectedRows.length > 0 &&
          !isEmpty(itemSelectedRows[0]._id)
        ? totals.totalAmount
        : netAmount,
    updatedBy: userId,
  };

  const expensesUpdatedListObj = Object.keys(expensesUpdatedList).forEach(
    (key) =>
      (expensesUpdatedList[key] == undefined ||
        expensesUpdatedList[key] === "") &&
      delete expensesUpdatedList[key]
  );

  console.log(expensesUpdatedListObj, "expensesUpdatedListObj");

  const updateExpenseApi = () => {
    if (simpleValidator.current.allValid()) {
      setIsButtonDisabled(true);
      setTimeout(() => {
        setIsButtonDisabled(false);
      }, 5000);
      api
        .put("/org/updateexpense", expensesUpdatedList)
        .then((res) => {
          toast.success("Expenses updated successfully");
          dispatch(loadExpensesList(orgList));
          setTimeout(() => {
            history.push("/expenses");
          }, 500);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            error &&
            error.response &&
            error.response.data &&
            error.response.data.message;
          toast.error(errorMsg || "An Error while adding the expenses");
          return Promise.reject(error);
        });
    } else {
      simpleValidator.current.showMessages();
      forceUpdate(1);
      if (itemSelectedRows.length >= 0 && itemSelectedRows[0].itemName == "") {
        toast.error("Expense Item fields are required");
      }
    }
  };

  //updated expense data
  useEffect(() => {
    if (updatedData) {
      const expenseUpdateDate =
        updatedData && updatedData.expenseDate ? updatedData.expenseDate : "";
      setExpenseData({
        ...expenseData,
        notes: updatedData.notes,
        expenseNumber: updatedData.expenseNo,
        invoiceNumber: updatedData.orginalInvoiceNo,
        categoryId: updatedData.categoryId,
        partyId: updatedData.partyId,
        accountId: updatedData.accountId,
        _id: updatedData._id,
      });
      setPaymentModeId(updatedData.paymentModeId);
      setExpenseDate(expenseUpdateDate);
      if (updatedData.isexpenseWithGST) {
        setExpenseWithGst(true);
      }
      if (updatedData.additionalCharges.length > 0) {
        setAdditionalChargesOpen(true);
      }
      const accountDetailsObj = updatedData && updatedData.accountDetails;

      const updatedAccountDetails =
        !isEmpty(accountDetailsObj.accountNumber) &&
        !isEmpty(accountDetailsObj.accountHolderName)
          ? `${accountDetailsObj.accountHolderName} - ${accountDetailsObj.accountNumber}`
          : isEmpty(accountDetailsObj.accountNumber) &&
            !isEmpty(accountDetailsObj.accountHolderName)
          ? accountDetailsObj.accountHolderName
          : "";

      if (updatedData.paymentModeName !== "Cash") {
        dispatch(loadPartyAccountList(orgList));
        setAccountList(updatedAccountDetails);
      }
      setPaymentMode(updatedData.paymentModeName);
      setCategories(updatedData.categoryName);
      setPartiesList(updatedData.partyName);

      const chargesValue =
        updatedData && updatedData.additionalCharges.length > 0
          ? updatedData.additionalCharges[0]
          : "";
      const chargeNameValue =
        updatedData && chargesValue ? chargesValue.chargeName : "";
      const chargeName = "No Tax Applicable";
      setDiscountAmount(updatedData.discountAmount);
      const listDataPercent =
        updatedData.discountAmount &&
        netAmount &&
        parseFloat((updatedData.discountAmount * 100) / netAmount).toFixed(2);
      setDiscountPercent(listDataPercent);

      if (updatedData.discountAmount) {
        setDiscountOpen(true);
      }
      //total section data
      setTotalSectionData({
        ...totalSectionData,
        totalAmount: updatedData.netTotalAmount,
        autoRoundOffValue: updatedData.autoamountroundoff
          ? updatedData.autoamountroundoff
          : "",
        chargesData: chargeNameValue,
        // netAmount: updatedData.NetAmount,
        additionalCharges:
          chargesValue && !isUndefined(chargesValue.chargeAmount)
            ? chargesValue.chargeAmount
            : 0,
        chargeId:
          chargesValue && !isUndefined(chargesValue._id)
            ? chargesValue._id
            : "",
      });
      setAdditionalOptions(chargeName);

      const expenseItemArray =
        updatedData && updatedData.expenseItem.length > 0
          ? updatedData.expenseItem.map((data, index) => {
              const gstPercentage = data.taxablePercentage;
              const quantityCount = data.qty;
              const totalPriceDataDetails =
                !isUndefined(quantityCount) &&
                data.priceofItem &&
                data.taxableAmount &&
                updatedData.isexpenseWithGST == true
                  ? parseFloat(quantityCount * data.priceofItem) +
                    data.taxableAmount
                  : !isUndefined(quantityCount) &&
                    data.priceofItem &&
                    data.taxableAmount == "" &&
                    updatedData.isexpenseWithGST == true
                  ? parseFloat(quantityCount * data.priceofItem)
                  : !isUndefined(quantityCount) &&
                    data.priceofItem &&
                    updatedData.isexpenseWithGST == false
                  ? parseFloat(quantityCount * data.priceofItem)
                  : 0;
              const totalPriceData = data.discountAmount
                ? parseFloat(totalPriceDataDetails - data.discountAmount)
                : totalPriceDataDetails;
              const taxablePercentageValue = `${data.taxablePercentage} %`;
              const qtyTax = parseFloat(data.taxableAmount / data.qty);
              return {
                index: index + 1,
                itemName: data.expenseItemName,
                itemNameValue: data.expenseItemName,
                itemChecked: true,
                _id: data.expenseitemId,
                expenseitemId: data.expenseitemId,
                itemCode: data.hsnCode ? data.hsnCode : "",
                salesPrice: data.salesPrice ? data.salesPrice : "",
                purchasePrice: data.priceofItem
                  ? parseFloat(data.priceofItem).toFixed(2)
                  : "",
                // purchasePriceValue: data.priceofItem ? data.priceofItem : "",
                createdAt: data.createdAt,
                createdBy: data.createdBy,
                customFields: data.customFields,
                categoryId: data.categoryId,
                categoryName: data.categoryName,
                categoryNameValue: data.categoryName,
                taxPercentageId: taxablePercentageValue,
                taxPercentageName: taxablePercentageValue,
                taxPercentageValue: gstPercentage,
                itemCodeValue: data.hsnCode,
                salesPriceValue: data.salesPrice,
                isWithTax: data.isWithTax == true ? true : false,
                isWithoutTax: data.isWithoutTax == true ? true : false,
                purchasePriceValue: data.taxableAmount
                  ? parseFloat(data.priceofItem + qtyTax)
                  : data.priceofItem,
                discountPrice:
                  data.discountAmount !== undefined ? data.discountAmount : 0,
                discountPercentage: !isUndefined(data.discountPercentage)
                  ? data.discountPercentage
                  : 0,
                taxPercentage: `${data.taxablePercentage} + " %"`,
                taxValue: data.taxableAmount,
                totalAmount:
                  totalPriceData && Number(totalPriceData).toFixed(2),
                quantityCount: data.qty,
                categoryIdValue: data.categoryId,
                hsnCode: data.hsnCode,
                descriptionValue: data.description,
                isProduct: data.isProduct,
                isService: data.isService,
                measuringId: data.measuringId,
                description: data.description,
                serialDetails: data.serialDetails,
                updatedAt: data.updatedAt,
                status: data.status,
              };
            })
          : [];
      setItemSelectedRows(expenseItemArray);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [updatedData]);

  const [isPrefixButtonDisabled, setIsPrefixButtonDisabled] = useState(false);
  //expense prefix settings
  const createPrefixSettings = () => {
    if (expensePrefixData.prefix && expensePrefixData.seqNo) {
      setIsPrefixButtonDisabled(true);
      setTimeout(() => {
        setIsPrefixButtonDisabled(false);
      }, 6000);
      const prefixList = {
        organizationId: organizationId,
        prefix: expensePrefixData.prefix,
        sequenceNo: expensePrefixData.seqNo,
        isType: "isExpense",
        isEnable: invoiceShow ? true : false,
        createdBy: userId,
      };
      api
        .post("/org/addnewsequenceno", prefixList)
        .then((res) => {
          dispatch(loadPrefixSettingsList(salesPrefixList));
          toast.success("Prefix updated successfully");
          setExpensePrefixData({
            ...expensePrefixData,
            expenseNumber: !isEmpty(expensePrefixData.seqNo)
              ? expensePrefixData.seqNo
              : !isEmpty(updatedData.expenseNo)
              ? updatedData.expenseNo
              : prefix_settings_list.lastsequenceNo,
            expensePrefix: expensePrefixData.prefix,
          });
          setPurchasePriceModal(false);
          setPrefixValidations(false);
          return res.data;
        })
        .catch((error) => {
          const errorMsg =
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.message) ||
            (error &&
              error.response &&
              error.response.data &&
              error.response.data.error);
          toast.error(errorMsg || "there is an issue while adding prefix");
          return Promise.reject(error);
        });
    } else {
      setPurchasePriceModal(true);
      setPrefixValidations(true);
    }
  };

  //prefix setting value listed

  useEffect(() => {
    if (prefix_settings_list && prefix_settings_list.isEnable == true) {
      setExpensePrefixData({
        ...expensePrefixData,
        prefix: prefix_settings_list.lastprefixName,
        expensePrefix: prefix_settings_list.lastprefixName,
        seqNo: prefix_settings_list.lastsequenceNo,
        expenseNumber:
          !isEmpty(updatedData) && updatedData !== undefined
            ? updatedData.expenseNo
            : prefix_settings_list.lastsequenceNo,
      });
      if (prefix_settings_list.isEnable == true) {
        setInvoiceShow(true);
      } else {
        setInvoiceShow(false);
      }
    } else if (updatedData !== undefined) {
      setExpensePrefixData({
        ...expensePrefixData,
        prefix: "",
        expensePrefix: "",
        seqNo: "",
        expenseNumber: updatedData.expenseNo,
        // invoiceNumber: orgLastInvoiceNo,
      });
      setInvoiceShow(false);
    } else {
      setExpensePrefixData({
        ...expensePrefixData,
        prefix: "",
        expensePrefix: "",
        seqNo: "",
        expenseNumber: "",
        // invoiceNumber: orgLastInvoiceNo,
      });
      setInvoiceShow(false);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [prefix_settings_list]);

  useBeforeUnload({
    when: !isEmpty(expenseData.invoiceNumber),
    message: "Are you sure you want to leave?",
  });

  //window height/width

  function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
      width,
      height,
    };
  }

  const [windowDimensions, setWindowDimensions] = useState(
    getWindowDimensions()
  );

  useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const dateFieldClasses =
    media == "sm"
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[200%] mt-2"
      : media == "xs"
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[125%] mt-2"
      : media == "lg" || media == "md"
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[100%]"
      : windowDimensions.width >= 1500 && windowDimensions.width < 1600
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[165%]"
      : windowDimensions.width >= 1600 && windowDimensions.width < 1700
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[182%]"
      : windowDimensions.width >= 1700 && windowDimensions.width < 1800
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[178%]"
      : windowDimensions.width >= 1800 && windowDimensions.width < 1900
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[198%]"
      : windowDimensions.width >= 1900 && windowDimensions.width < 2000
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[223%]"
      : windowDimensions.width >= 2000
      ? "profit-loss-label rounded-sm border border-1 h-[40px] w-[235%]"
      : "profit-loss-label rounded-sm border border-1 h-[40px] w-[130%]";

  const iconCalendarClasses =
    media == "sm"
      ? "top-[12px] text-[16px] right-[-183px] text-[#9e9e9e]"
      : media == "xs"
      ? "top-[12px] text-[16px] right-[-30px] text-[#9e9e9e]"
      : media == "md" || media == "lg"
      ? "top-[2px] text-[16px] right-[3px] text-[#9e9e9e]"
      : windowDimensions.width >= 1500 && windowDimensions.width < 1600
      ? "top-[2px] text-[16px] right-[-88px] text-[#9e9e9e]"
      : windowDimensions.width >= 1600 && windowDimensions.width < 1700
      ? "top-[2px] text-[16px] right-[-108px] text-[#9e9e9e]"
      : windowDimensions.width >= 1700 && windowDimensions.width < 1800
      ? "top-[2px] text-[16px] right-[-128px] text-[#9e9e9e]"
      : windowDimensions.width >= 1800 && windowDimensions.width < 1900
      ? "top-[2px] text-[16px] right-[-168px] text-[#9e9e9e]"
      : windowDimensions.width >= 1900 && windowDimensions.width < 2000
      ? "top-[2px] text-[16px] right-[-188px] text-[#9e9e9e]"
      : windowDimensions.width >= 2000
      ? "top-[2px] text-[16px] right-[-218px] text-[#9e9e9e]"
      : "top-[2px] text-[16px] right-[-55px] text-[#9e9e9e]";
  return (
    <React.Fragment>
      <div className="">
        <MetaTags>
          <title>Create Expenses | Mbook</title>
        </MetaTags>
      </div>

      <Row
        // onMouseEnter={() => setMouseHover(true)}
        // onMouseLeave={() => setMouseHover(false)}
        className="border-solid rounded-sm"
      >
        <Col span={24}>
          <div
            className={
              media == "sm" || media == "xs"
                ? "font-poppins flex flex-col bg-[#ffffff] pt-3 pb-3 pl-[20px] pr-[20px] mt-1"
                : "font-poppins flex bg-[#ffffff] justify-between pt-3 pb-3 pl-[20px] pr-[20px] mt-1"
            }
          >
            <div className="flex">
              <ArrowLeftOutlined
                onClick={() => setPageRouting(true)}
                className="font-bold text-[18px]"
              />
              <h1
                style={{
                  fontFamily: "Poppins",
                }}
                className="text-[18px] ml-2 mt-1 font-semibold"
              >
                {!isEmpty(updatedData) ? "Update Expenses" : "Create Expenses"}
              </h1>
            </div>
            <div
              className={media == "sm" || media == "xs" ? "flex-col" : "flex"}
            >
              <Tooltip
                title="Introducing custom fields -> Now you can add custom party fields like Drug licence number, ID, etc.,"
                placement="bottom"
                rootClassName="text-[10px]"
              >
                <div
                  onClick={() => setPurchasePriceModal(true)}
                  className={
                    media == "sm" || media == "xs"
                      ? "border rounded-md mr-3 mt-3 text-center pt-1.5 pb-1.5 pr-2 pl-2 cursor-pointer"
                      : "border rounded-md mr-3 pt-1.5 pb-1.5 pr-2 pl-2 cursor-pointer"
                  }
                >
                  <SettingOutlined />
                </div>
              </Tooltip>
              <div
                onClick={() => cancelPaymentIn()}
                className={
                  media == "sm" || media == "xs"
                    ? "border rounded-md hover:bg-[#efefef] mt-3 mr-3 text-center pl-8 pr-8 p-1 cursor-pointer"
                    : "border rounded-md hover:bg-[#efefef] ml-3 pl-8 pr-8 p-1 cursor-pointer"
                }
              >
                Cancel
              </div>
              {!isEmpty(updatedData) ? (
                <div
                  onClick={() => updateExpenseApi()}
                  style={{
                    opacity: isButtonDisabled ? 2 : "",
                    pointerEvents: isButtonDisabled ? "none" : "",
                  }}
                  className={
                    media == "sm" || media == "xs"
                      ? "border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md mt-3 text-center mr-3 pl-8 pr-8 p-1.5 cursor-pointer"
                      : "border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md ml-3 pl-8 pr-8 p-1.5 cursor-pointer"
                  }
                >
                  Update
                </div>
              ) : (
                <div
                  style={{
                    opacity: isButtonDisabled ? 2 : "",
                    pointerEvents: isButtonDisabled ? "none" : "",
                  }}
                  onClick={() => createExpensesApi()}
                  className={
                    media == "sm" || media == "xs"
                      ? "border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md mt-3 text-center mr-3 pl-8 pr-8 p-1.5 cursor-pointer"
                      : "border bg-[#1a276dd4] hover:bg-[#7163c1] text-[#ffffff] rounded-md ml-3 pl-8 pr-8 p-1.5 cursor-pointer"
                  }
                >
                  Save
                </div>
              )}
            </div>
          </div>
        </Col>
        <div
          className={
            (media === "sm" || media === "xs") && windowDimensions.height < 650
              ? "add-expenses-mobile-main pr-1 pb-3"
              : (media === "sm" || media === "xs") &&
                windowDimensions.height > 650 &&
                windowDimensions.height < 730
              ? "add-expenses-mobile-main-medium-device pr-1 pb-3"
              : (media === "sm" || media === "xs") &&
                windowDimensions.height > 730 &&
                windowDimensions.height < 830
              ? "add-expenses-mobile-main-tab-device pr-1 pb-3"
              : (media === "sm" || media === "xs") &&
                windowDimensions.height > 830 &&
                windowDimensions.height < 900
              ? "add-expenses-mobile-main-large-device pr-1 pb-3"
              : (media === "sm" || media === "xs") &&
                windowDimensions.height > 900 &&
                windowDimensions.height < 1000
              ? "add-expenses-mobile-main-extra-large-device pr-1 pb-3"
              : (media === "sm" || media === "xs") &&
                windowDimensions.height > 1000
              ? "add-expenses-mobile-main-extra-extra-large-device pr-1 pb-3"
              : (media !== "sm" || media !== "xs") &&
                windowDimensions.height > 600 &&
                windowDimensions.height < 650
              ? "add-expenses-main-card-mobile pl-3 pb-3"
              : (media !== "sm" || media !== "xs") &&
                windowDimensions.height > 650 &&
                windowDimensions.height < 700 &&
                !expenseWithGst
              ? "add-expenses-main-card-medium-device-without-gst pl-2 pb-3"
              : (media !== "sm" || media !== "xs") &&
                windowDimensions.height > 650 &&
                windowDimensions.height < 700 &&
                expenseWithGst
              ? "add-expenses-main-card-medium pl-2 pb-3"
              : (media !== "sm" || media !== "xs") &&
                windowDimensions.height > 730 &&
                windowDimensions.height < 830 &&
                !expenseWithGst &&
                itemSelectedRows &&
                itemSelectedRows.length > 0 &&
                isEmpty(itemSelectedRows[0]._id)
              ? "add-expenses-main-card-medium-without-gst-not-selected-item"
              : (media !== "sm" || media !== "xs") &&
                windowDimensions.height > 730 &&
                windowDimensions.height < 830 &&
                !expenseWithGst &&
                itemSelectedRows &&
                itemSelectedRows.length > 0 &&
                !isEmpty(itemSelectedRows[0]._id)
              ? "add-expenses-main-card-medium-without-gst"
              : (media !== "sm" || media !== "xs") &&
                windowDimensions.height > 700 &&
                windowDimensions.height < 830 &&
                expenseWithGst
              ? "add-expenses-main-card-medium-gst"
              : (media !== "sm" || media !== "xs") &&
                windowDimensions.height > 830 &&
                windowDimensions.height < 900 &&
                !expenseWithGst
              ? "add-expenses-main-card-extra-large-device-without-gst"
              : (media !== "sm" || media !== "xs") &&
                windowDimensions.height > 830 &&
                windowDimensions.height < 900 &&
                expenseWithGst
              ? "add-expenses-main-card-extra-large-device-gst"
              : (media !== "sm" || media !== "xs") &&
                windowDimensions.height > 900 &&
                windowDimensions.height < 1000 &&
                !expenseWithGst
              ? "add-expenses-main-card-extra-extra-large-device-without-gst pl-2 pb-3"
              : (media !== "sm" || media !== "xs") &&
                windowDimensions.height > 900 &&
                windowDimensions.height < 1000 &&
                expenseWithGst
              ? "add-expenses-main-card-extra-extra-large-device-gst pl-2 pb-3"
              : (media !== "sm" || media !== "xs") &&
                windowDimensions.height > 1000 &&
                !expenseWithGst &&
                itemSelectedRows &&
                itemSelectedRows.length > 0 &&
                isEmpty(itemSelectedRows[0]._id)
              ? "add-expenses-main-card-item-not-selected-infinite-large-device-gst"
              : (media !== "sm" || media !== "xs") &&
                windowDimensions.height > 1000 &&
                expenseWithGst &&
                itemSelectedRows &&
                itemSelectedRows.length > 0 &&
                isEmpty(itemSelectedRows[0]._id)
              ? "add-expenses-main-card-item-not-selected-extra-extra-large-device-gst"
              : (media !== "sm" || media !== "xs") &&
                windowDimensions.height > 1000 &&
                expenseWithGst &&
                itemSelectedRows &&
                itemSelectedRows.length > 0 &&
                !isEmpty(itemSelectedRows[0]._id)
              ? "add-expenses-main-card-item-selected-infinite-large-device-gst"
              : // : (media !== "sm" || media !== "xs") &&
              //   windowDimensions.height > 1000 &&
              //   expenseWithGst &&
              //   itemSelectedRows &&
              //   itemSelectedRows.length > 1 &&
              //   !isEmpty(itemSelectedRows[0]._id)
              // ? "add-expenses-main-card-item-selected-infinite-extra-large-device-gst"
              (media !== "sm" || media !== "xs") &&
                windowDimensions.height > 1000 &&
                !expenseWithGst &&
                itemSelectedRows &&
                itemSelectedRows.length > 0 &&
                !isEmpty(itemSelectedRows[0]._id)
              ? "add-expenses-main-card-item-selected-infinite-array-large-device-gst"
              : "add-expenses-main-card-medium pl-2 pb-3"
          }
        >
          <Col span={24}>
            <Row>
              {/* Form section */}
              <Col
                md={12}
                sm={24}
                lg={12}
                xs={24}
                className={
                  // windowDimensions.height > 700 && windowDimensions.height < 830
                  //   ? "add-expenses-main-card-large-device border border-solid border-lightgray-200 p-4 rounded-md bg-[#ffffff] mt-4"
                  //   : windowDimensions.height > 830 &&
                  //     windowDimensions.height < 900 &&
                  //     !expenseWithGst
                  //   ? "add-expenses-main-card-extra-large-device border border-solid border-lightgray-200 p-4 rounded-md bg-[#ffffff] mt-4"
                  //   : windowDimensions.height > 830 &&
                  //     windowDimensions.height < 900 &&
                  //     expenseWithGst
                  //   ? "add-expenses-main-card-extra-large-device-with-gst border border-solid border-lightgray-200 p-4 rounded-md bg-[#ffffff] mt-4"
                  //   : windowDimensions.height > 900 &&
                  //     windowDimensions.height < 1000 &&
                  //     !expenseWithGst
                  //   ? "add-expenses-main-card-extra-extra-large-device border border-solid border-lightgray-200 p-4 rounded-md bg-[#ffffff] mt-4"
                  //   : windowDimensions.height > 900 &&
                  //     windowDimensions.height < 1000 &&
                  //     expenseWithGst
                  //   ? "add-expenses-main-card-extra-extra-large-device-with-gst border border-solid border-lightgray-200 p-4 rounded-md bg-[#ffffff] mt-4"
                  //   : windowDimensions.height > 1000 && !expenseWithGst
                  //   ? "add-expenses-main-card-extra-infinite-device border border-solid border-lightgray-200 p-4 rounded-md bg-[#ffffff] mt-4"
                  //   : windowDimensions.height > 1000 && expenseWithGst
                  //   ? "add-expenses-main-card-extra-infinite-device-with-gst border border-solid border-lightgray-200 p-4 rounded-md bg-[#ffffff] mt-4"
                  //   :
                  expenseWithGst === true
                    ? "add-expenses-main-card-small-with-gst border border-solid border-lightgray-200 p-4 rounded-md bg-[#ffffff] mt-2"
                    : "add-expenses-main-card-small border border-solid border-lightgray-200 p-4 rounded-md bg-[#ffffff] mt-2"
                }
              >
                <div className="w-[100%] flex justify-between mb-3 border border-1 p-3 rounded-md">
                  <h1 className="expense-label text-[12px] mb-1">
                    Expense With GST
                  </h1>
                  <Switch
                    value={expenseWithGst}
                    onChange={(checked) => setExpenseWithGst(checked)}
                  />
                </div>
                {/* {expenseWithGst === true ? ( */}
                <div className="w-[100%] mt-4 mb-2">
                  <Typography className="expense-label text-[12px]">
                    Party
                  </Typography>
                  <Select
                    name="partiesList"
                    value={partiesList}
                    onChange={(e) => setPartiesList(e)}
                    placeholder="Select Party"
                    options={partyOptions}
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className={"w-[100%] h-[40px]"}
                  />
                </div>
                {/* ) : (
                  ""
                )} */}

                <div className="w-[100%] mt-4 mb-2">
                  <Typography className="expense-label flex text-[12px]">
                    Expense Category
                    <p className="text-[red] text-[12px] ml-2">*</p>
                  </Typography>
                  <Select
                    value={categories}
                    onChange={(e) => setCategories(e)}
                    placeholder="Select Categories"
                    style={{
                      fontFamily: "Poppins",
                    }}
                    className={"w-[100%] h-[40px]"}
                    dropdownRender={(menu) => (
                      <>
                        {menu}
                        <Divider
                          style={{
                            margin: "8px 0",
                          }}
                        />
                        <div className="pl-2 pr-2">
                          <Button
                            type="dashed"
                            icon={<PlusOutlined />}
                            onClick={() => setAddCategoryModal(true)}
                            className="w-[100%] text-blue-500 border border-2 mt-1 mb-1 border-blue-300"
                          >
                            Add / Manage Category
                          </Button>
                        </div>
                      </>
                    )}
                    options={categoryOptions}
                  />
                  <p className="text-[11px] text-[red]">
                    {simpleValidator.current.message(
                      "categories",
                      categories,
                      "required"
                    )}
                  </p>
                </div>
                <div className="flex flex-row">
                  {prefix_settings_list &&
                  prefix_settings_list.isEnable == true ? (
                    <div
                      className={
                        media === "sm" || media === "xs"
                          ? "w-[100%] mb-3"
                          : "w-[50%] mb-3 pr-3"
                      }
                    >
                      <Typography className="expense-label flex text-[12px]">
                        Expense Prefix
                        <p className="text-[red] text-[12px] ml-2">*</p>
                      </Typography>
                      <Input
                        name="expensePrefix"
                        value={expensePrefixData.expensePrefix}
                        onChange={(e) => handleExpensePrefixChange(e)}
                        placeholder="Enter Expense Prefix"
                        className="p-2"
                        disabled
                      />
                      {/* <p className="text-[11px] text-[red]">
                    {simpleValidator.current.message(
                      "expensePrefix",
                      expensePrefixData.expensePrefix,
                      "required"
                    )}
                  </p> */}
                    </div>
                  ) : (
                    ""
                  )}

                  <div
                    className={
                      media === "sm" || media === "xs"
                        ? "w-[100%] mb-3"
                        : "w-[50%] mb-3"
                    }
                  >
                    <Typography className="expense-label flex text-[12px]">
                      Expense Number
                      <p className="text-[red] text-[12px] ml-2">*</p>
                    </Typography>
                    <Input
                      name="expenseNumber"
                      value={expensePrefixData.expenseNumber}
                      onChange={(e) => handleExpensePrefixChange(e)}
                      placeholder="Enter Expense Number"
                      className="p-2"
                      disabled={
                        prefix_settings_list &&
                        prefix_settings_list.isEnable == true
                          ? true
                          : false
                      }
                    />
                    <p className="text-[11px] text-[red]">
                      {simpleValidator.current.message(
                        "expenseNumber",
                        expensePrefixData.expenseNumber,
                        "required"
                      )}
                    </p>
                  </div>
                </div>
              </Col>
              <Col
                md={12}
                sm={24}
                lg={12}
                xs={24}
                // className={

                // }
              >
                <Row
                  className={
                    media === "sm" || media === "xs"
                      ? "mt-3 border border-solid border-lightgray-200 p-3 rounded-md bg-[#ffffff]"
                      : expenseWithGst === true
                      ? "add-expenses-main-card-small-with-gst ml-3 mt-2 pr-[15px] border border-solid border-lightgray-200 p-3 mr-2 rounded-md bg-[#ffffff]"
                      : "add-expenses-main-card-small ml-3 mt-2 pr-[15px] border border-solid border-lightgray-200 p-3 mr-2 rounded-md bg-[#ffffff]"
                  }
                  // className={
                  //   media === "sm" || media === "xs"
                  //     ? "mt-3 border border-solid border-lightgray-200 p-3 rounded-md bg-[#ffffff]"
                  //     : windowDimensions.height > 700 &&
                  //       windowDimensions.height < 830
                  //     ? "add-expenses-main-card-large-device ml-3 mt-4 border border-solid border-lightgray-200 p-3 rounded-md bg-[#ffffff]"
                  //     : windowDimensions.height > 830 &&
                  //       windowDimensions.height < 900
                  //     ? "add-expenses-main-card-extra-large-device ml-3 mt-4 border border-solid border-lightgray-200 p-3 rounded-md bg-[#ffffff]"
                  //     : windowDimensions.height > 900 &&
                  //       windowDimensions.height < 1000
                  //     ? "add-expenses-main-card-extra-extra-large-device ml-3 mt-4 bg-[#ffffff]"
                  //     : windowDimensions.height > 1000
                  //     ? "add-expenses-main-card-extra-infinite-device ml-3 mt-4 border border-solid border-lightgray-200 p-3 rounded-md bg-[#ffffff]"
                  //     : expenseWithGst === true
                  //     ? "add-expenses-main-card-small-with-gst ml-3 mt-2 pr-[10px] border border-solid border-lightgray-200 p-3 mr-2 rounded-md bg-[#ffffff]"
                  //     : "add-expenses-main-card-small ml-3 mt-2 pr-[10px] border border-solid border-lightgray-200 p-3 mr-2 rounded-md bg-[#ffffff]"
                  // }
                >
                  <Col md={12} sm={24} lg={12} xs={24} className="pr-4 mb-3">
                    <Typography className="expense-label flex text-[12px]">
                      Org Invoice Number
                      <p className="text-[red] text-[12px] ml-2">*</p>
                    </Typography>
                    <Input
                      name="invoiceNumber"
                      value={expenseData.invoiceNumber}
                      onChange={(e) => handleChange(e)}
                      placeholder=""
                      className="p-2"
                    />
                    <p className="text-[11px] text-[red]">
                      {simpleValidator.current.message(
                        "invoiceNumber",
                        expenseData.invoiceNumber,
                        "required"
                      )}
                    </p>
                  </Col>
                  <Col md={12} sm={24} lg={12} xs={24} className="pr-4 mb-3">
                    <Typography className="expense-label flex text-[12px]">
                      Date <p className="text-[red] text-[12px] ml-2">*</p>
                    </Typography>
                    <DatePicker
                      selected={expenseDate}
                      className={dateFieldClasses}
                      style={{
                        fontFamily: "Poppins",
                      }}
                      // value={moment()}
                      onChange={(date) => setExpenseDate(date)}
                      icon={
                        <BiCalendar
                          //   size={30}
                          className={iconCalendarClasses}
                        />
                      }
                      popperClassName={"z-10"}
                      showIcon
                      placeholderText="Select Date"
                    />
                    <p className="text-[11px] text-[red]">
                      {simpleValidator.current.message(
                        "expenseDate",
                        expenseDate,
                        "required"
                      )}
                    </p>
                  </Col>
                  <Col
                    md={12}
                    sm={24}
                    lg={12}
                    xs={24}
                    className={
                      expenseWithGst === true ? "mt-6 pr-2 mb-2" : "pr-2 mb-2"
                    }
                  >
                    <Typography className="expense-label flex text-[12px]">
                      Payment Mode
                      <p className="text-[red] text-[12px] ml-2">*</p>
                    </Typography>
                    <Select
                      name="paymentMode"
                      value={paymentMode}
                      onChange={(e) => {
                        setPaymentMode(e);
                        dispatch(loadPartyAccountList(orgList));
                        setAccountList([]);
                      }}
                      placeholder="Select Payment Mode"
                      className="w-[100%] h-[40px]"
                      options={
                        expenseMetaData
                          ? expenseMetaData.paymentModeOptions
                          : []
                      }
                    />
                    <p className="text-[11px] text-[red]">
                      {simpleValidator.current.message(
                        "paymentMode",
                        paymentMode,
                        "required"
                      )}
                    </p>
                  </Col>
                  {((!isEmpty(paymentMode) || paymentMode.length > 0) &&
                    paymentMode == "Cash") ||
                  paymentMode == "66c9bd5ab3fca462ca48a87e" ? (
                    ""
                  ) : (
                    <Col
                      md={12}
                      sm={24}
                      lg={12}
                      xs={24}
                      className={
                        expenseWithGst == true ? "mt-6 pr-4 mb-2" : "pr-4 mb-2"
                        // media === "xxl" ? "pr-4 mb-2" : "pr-4 mb-2"
                      }
                    >
                      <Typography className="expense-label text-[12px] mb-[12px]">
                        Account Number
                      </Typography>
                      <Select
                        name="accountList"
                        value={accountList}
                        onChange={(e) => setAccountList(e)}
                        placeholder="Select Account Number"
                        style={{
                          fontFamily: "Poppins",
                        }}
                        options={partyAccountOptions}
                        className="w-[100%] h-[40px]"
                      />
                    </Col>
                  )}

                  <Col
                    span={24}
                    className={
                      expenseWithGst === true ? "mt-6 mb-2 pr-2" : "mb-2 pr-2"
                    }
                  >
                    <Typography className="expense-label text-[12px]">
                      Notes
                    </Typography>
                    <Input.TextArea
                      name="notes"
                      value={expenseData.notes}
                      onChange={(e) => handleChange(e)}
                      placeholder="Enter Notes"
                      className="p-3"
                    />
                  </Col>
                </Row>
              </Col>
              {/* Add item section */}
              <Col
                span={24}
                className={
                  (media === "sm" || media === "xs") &&
                  windowDimensions.height > 600 &&
                  windowDimensions.height < 700
                    ? "h-[500px] mt-3 pb-2 bg-[#ffffff]"
                    : (media === "sm" || media === "xs") &&
                      windowDimensions.height > 700 &&
                      windowDimensions.height < 800
                    ? "h-[550px] mt-3 pb-2 bg-[#ffffff]"
                    : (media === "sm" || media === "xs") &&
                      windowDimensions.height > 800 &&
                      windowDimensions.height < 900
                    ? "h-[600px] mt-3 pb-2 bg-[#ffffff]"
                    : (media === "sm" || media === "xs") &&
                      windowDimensions.height > 900 &&
                      windowDimensions.height < 1000
                    ? "h-[650px] mt-3 pb-2 bg-[#ffffff]"
                    : (media === "sm" || media === "xs") &&
                      windowDimensions.height > 1000 &&
                      itemSelectedRows &&
                      itemSelectedRows.length > 0 &&
                      !isEmpty(itemSelectedRows[0]._id)
                    ? "h-[700px] mt-3 pb-2 bg-[#ffffff]"
                    : (media === "sm" || media === "xs") &&
                      windowDimensions.height > 1000 &&
                      !expenseWithGst &&
                      itemSelectedRows &&
                      itemSelectedRows.length > 0 &&
                      isEmpty(itemSelectedRows[0]._id)
                    ? "h-[300px] mt-3 pb-2 bg-[#ffffff]"
                    : windowDimensions.height > 700 &&
                      windowDimensions.height < 800
                    ? "h-[300px] mt-3 pb-2 bg-[#ffffff]"
                    : windowDimensions.height > 800 &&
                      windowDimensions.height < 900
                    ? "h-[350px] mt-3 pb-2 bg-[#ffffff]"
                    : windowDimensions.height > 900 &&
                      windowDimensions.height < 1000
                    ? "h-[400px] mt-3 pb-2 bg-[#ffffff]"
                    : windowDimensions.height > 1000 &&
                      !expenseWithGst &&
                      windowDimensions.height > 1000 &&
                      itemSelectedRows &&
                      itemSelectedRows.length > 0 &&
                      isEmpty(itemSelectedRows[0]._id)
                    ? "h-[500px] mt-3 pb-2 bg-[#ffffff]"
                    : windowDimensions.height > 1000 &&
                      !expenseWithGst &&
                      windowDimensions.height > 1000 &&
                      itemSelectedRows &&
                      itemSelectedRows.length > 0 &&
                      !isEmpty(itemSelectedRows[0]._id)
                    ? "h-[550px] mt-3 pb-2 bg-[#ffffff]"
                    : windowDimensions.height > 1000 && expenseWithGst
                    ? "h-[560px] mt-3 pb-2 bg-[#ffffff]"
                    : "mt-3 pb-2 bg-[#ffffff]"
                }
              >
                <Row>
                  {itemSelectedRows &&
                  itemSelectedRows.length > 0 &&
                  !isEmpty(itemSelectedRows[0].itemName) ? (
                    <Col
                      span={24}
                      className="p-2 add-create-item-table  border border-x-0 border-y-0"
                    >
                      <table className="table-purchase-serial table-responsive">
                        <thead>
                          <tr>
                            <th className="table-head text-center uppercase text-[12px] font-medium">
                              No
                            </th>
                            <th className="w-[28%] table-head uppercase text-[12px] font-medium">
                              Items/ Services
                            </th>
                            {expenseWithGst === true ? (
                              <th className="w-[8%] table-head uppercase text-[12px] font-medium">
                                HSN Code
                              </th>
                            ) : (
                              ""
                            )}

                            <th
                              className={
                                expenseWithGst === true
                                  ? "w-[10%] table-head uppercase text-[12px] font-medium"
                                  : "w-[15%] table-head uppercase text-[12px] font-medium"
                              }
                            >
                              Qty
                            </th>

                            <th
                              className={
                                expenseWithGst === true
                                  ? "w-[11%] table-head uppercase text-[12px] font-medium"
                                  : "w-[15%] table-head uppercase text-[12px] font-medium"
                              }
                            >
                              Price (₹)
                            </th>

                            {expenseWithGst === true ? (
                              <th className="w-[10%] table-head uppercase text-[12px] font-medium">
                                Discount
                              </th>
                            ) : (
                              ""
                            )}
                            {expenseWithGst === true ? (
                              <th className="w-[11%] table-head uppercase text-[12px] font-medium">
                                Tax
                              </th>
                            ) : (
                              ""
                            )}
                            <th
                              className={
                                expenseWithGst === true
                                  ? "w-[11%] table-head uppercase text-[12px] font-medium"
                                  : "w-[16%] table-head uppercase text-[12px] font-medium"
                              }
                            >
                              Amount (₹)
                            </th>
                            <th className="table-head text-center uppercase text-[12px] font-medium">
                              {/* <div
                              className="cursor-pointer"
                              onClick={() => setColumnSettings(true)}
                            >
                              <PlusCircleFilled className="text-[30px] text-[#8b8787]" />
                            </div> */}{" "}
                              #
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          {itemSelectedRows &&
                          itemSelectedRows.length > 0 &&
                          !isEmpty(itemSelectedRows[0].itemName) ? (
                            itemSelectedRows.map((data, index) => {
                              const taxFinalValue = data.quantityCount
                                ? parseFloat(data.taxValue).toFixed(2)
                                : data.taxValue;
                              return (
                                <tr
                                  key={index}
                                  className="table-purchase-orders-row p-2"
                                >
                                  <td className="table-data font-medium text-center">
                                    {index + 1}
                                  </td>
                                  <td className="table-data purchase-label font-semibold font-medium text-start">
                                    {data.itemName}

                                    {/* <Input
                                      name="itemDescription"
                                      value={data.itemDescription}
                                      className="p-2 mt-[3px] h-[35px] bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                      placeholder="Enter Description (optional)"
                                      onChange={(e) =>
                                        itemSelectedChange(
                                          e,
                                          "itemDescription",
                                          index
                                        )
                                      }
                                    /> */}
                                  </td>
                                  {expenseWithGst === true ? (
                                    <td className="table-data font-medium text-start">
                                      {data.hsnCode}
                                    </td>
                                  ) : (
                                    ""
                                  )}

                                  <td className="table-data font-medium text-start">
                                    <Input
                                      name="quantityCount"
                                      value={data.quantityCount}
                                      className="p-2 h-[35px] purchase-orders-inputs text-end bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                      placeholder="Enter Qty (optional)"
                                      onChange={(e) =>
                                        itemSelectedChange(
                                          e,
                                          "quantityCount",
                                          index
                                        )
                                      }
                                      style={{
                                        textAlign: "end",
                                      }}
                                      suffix={"PCS"}
                                    />{" "}
                                    {/* PCS */}
                                  </td>

                                  <td className="table-data font-medium text-center">
                                    <Input
                                      name="purchasePrice"
                                      value={data.purchasePrice}
                                      prefix={"₹"}
                                      className="p-2 h-[35px] purchase-orders-inputs text-end bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                      placeholder="Enter price"
                                      onChange={(e) =>
                                        itemSelectedChange(
                                          e,
                                          "purchasePrice",
                                          index
                                        )
                                      }
                                      style={{
                                        textAlign: "right",
                                      }}
                                    />
                                  </td>
                                  {expenseWithGst === true ? (
                                    <td className="table-data font-medium">
                                      <Input
                                        name="discountPercentage"
                                        suffix={"%"}
                                        value={data.discountPercentage}
                                        className="p-2 mb-1 h-[30px] bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                        placeholder="%"
                                        onChange={(e) =>
                                          itemSelectedChange(
                                            e,
                                            "discountPercentage",
                                            index
                                          )
                                        }
                                      />

                                      <Input
                                        name="discountPrice"
                                        value={data.discountPrice}
                                        className="p-2 h-[30px] purchase-orders-inputs bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                        placeholder="price"
                                        prefix={"₹"}
                                        onChange={(e) =>
                                          itemSelectedChange(
                                            e,
                                            "discountPrice",
                                            index
                                          )
                                        }
                                      />
                                    </td>
                                  ) : (
                                    ""
                                  )}
                                  {expenseWithGst === true ? (
                                    <td className="table-data font-medium">
                                      <Select
                                        name="taxPercentageId"
                                        value={data.taxPercentageId}
                                        options={
                                          recordsMetaData
                                            ? recordsMetaData.gstPercentageOptions
                                            : []
                                        }
                                        onChange={(e) =>
                                          itemSelectedChange(
                                            e,
                                            "taxPercentageId",
                                            index
                                          )
                                        }
                                        className="h-[40px] w-[100%] border-none hover:bg-[#e9ecf1]"
                                        placeholder="% 0"
                                      />
                                      <p className="text-center mt-1">
                                        {data.taxValue
                                          ? `(₹ ${taxFinalValue})`
                                          : ""}
                                      </p>
                                    </td>
                                  ) : (
                                    ""
                                  )}
                                  <td className="table-data font-medium text-center">
                                    <Input
                                      name="totalAmount"
                                      value={data.totalAmount}
                                      className="p-2 h-[35px] purchase-orders-inputs bg-[#e9ecf1] border-none focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                                      placeholder="Enter price"
                                      prefix={"₹"}
                                      onChange={(e) =>
                                        itemSelectedChange(
                                          e,
                                          "totalAmount",
                                          index
                                        )
                                      }
                                    />
                                  </td>
                                  <td className="table-data font-medium text-center">
                                    <DeleteOutlined
                                      onClick={() => removeItemsData(index)}
                                      type="primary"
                                      className="ml-3 border rounded-md p-2 text-[red] cursor-pointer"
                                      size={"large"}
                                    />
                                  </td>
                                </tr>
                              );
                            })
                          ) : (
                            <tr key={0}>
                              <td colSpan={11} className="text-center"></td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                    </Col>
                  ) : (
                    ""
                  )}
                  <Col span={24} className="p-3">
                    <div
                      style={{
                        fontFamily: "Poppins",
                      }}
                      onClick={() => {
                        setItemModal(true);
                        dispatch(loadExpensesItemList(orgList));
                        // dispatch(loadItemsRecordsMetaData());
                        // setItemSelectedRows([
                        //   {
                        //     itemName: "",
                        //     itemChecked: "",
                        //     itemNameValue: "",
                        //     taxPercentageValue: "",
                        //     itemDescription: "",
                        //     itemCode: "",
                        //     measuringUnitName: "",
                        //     gstrateId: "",
                        //     itcApplicableId: "",
                        //     measuringUnitId: "",
                        //     gstrateName: "",
                        //     itcApplicableName: "",
                        //     salesPrice: "",
                        //     purchasePrice: "",
                        //     discountPrice: "",
                        //     discountPercentage: "",
                        //     taxPercentage: "",
                        //     taxValue: "",
                        //     taxPercentageId: "",
                        //     taxPercentageName: "",
                        //     totalAmount: "",
                        //     hsnCode: "",
                        //     stockQTY: "",
                        //     quantityCount: "",
                        //     createdAt: "",
                        //     createdBy: "",
                        //     isProduct: "",
                        //     isService: "",
                        //     expenseitemId: "",
                        //     qty: "",
                        //     priceofItem: "",
                        //     discountAmount: "",
                        //     taxableAmount: "",
                        //     taxablePercentage: "",
                        //     itemAmount: "",
                        //     _id: "",
                        //     index: "",
                        //     action: "",
                        //     status: "",
                        //   },
                        // ]);
                      }}
                      className="cursor-pointer border font-semibold text-center text-blue-400 border-dashed border-blue-400 border-2 p-2 w-[100%]"
                    >
                      + Add Item
                    </div>
                  </Col>
                </Row>

                {expenseWithGst === true ? (
                  <>
                    {/* Total section */}
                    <Row
                      className={
                        media === "sm" || media === "xs"
                          ? "w-[100%] flex flex-col bg-gray-50 p-2 border border-x-0 pl-5 pr-5 mt-3"
                          : "w-[100%] bg-gray-50 p-2 border border-x-0 pl-5 pr-5 mt-3"
                      }
                    >
                      <Col
                        md={13}
                        sm={24}
                        xl={15}
                        xxl={15}
                        lg={15}
                        xs={24}
                        className={
                          media === "sm" || media === "xs"
                            ? "flex justify-center"
                            : "flex justify-end"
                        }
                      >
                        <div className="flex">
                          <h1
                            className={
                              media === "sm" || media === "xs"
                                ? "text-[14px] pr-2 purchase-label font-semibold mb-[-8px]"
                                : "text-[14px] pr-2 purchase-label font-semibold"
                            }
                          >
                            Total
                          </h1>
                          {media === "sm" || media === "xs" ? (
                            ""
                          ) : (
                            <Divider
                              type={"vertical"}
                              className={
                                media === "md"
                                  ? "h-[50px] total-divider"
                                  : "h-[40px] total-divider"
                              }
                            />
                          )}
                        </div>
                      </Col>
                      <Col
                        md={3}
                        sm={24}
                        xl={3}
                        xxl={3}
                        lg={3}
                        xs={24}
                        className=""
                      >
                        <div
                          className={
                            media === "sm" || media === "xs"
                              ? "flex flex-col"
                              : "flex"
                          }
                        >
                          {media === "sm" || media === "xs" ? (
                            <Divider
                              type={"horizontal"}
                              className="h-[0px] w-[107%] ml-[-20px]"
                            />
                          ) : (
                            ""
                          )}
                          <h1
                            className={
                              media === "sm" || media === "xs"
                                ? "text-[14px] pr-4 mb-[-8px] mt-[-8px] flex flex-center font-semibold"
                                : "text-[14px] pr-4 text-end font-semibold"
                            }
                          >
                            <div className="flex">
                              <p>₹</p>
                              <h1 className="ml-1 purchase-label text-[14px] mt-[1px]">
                                {itemSelectedRows &&
                                itemSelectedRows.length > 0 &&
                                totals.discountPrice > 0
                                  ? parseFloat(totals.discountPrice).toFixed(2)
                                  : 0}
                              </h1>
                            </div>
                          </h1>
                          {media === "sm" || media === "xs" ? (
                            <Divider
                              type={"horizontal"}
                              className="h-[0px] w-[107%] ml-[-20px]"
                            />
                          ) : (
                            <Divider
                              type={"vertical"}
                              className={
                                media === "md"
                                  ? "h-[50px] total-divider"
                                  : "h-[40px] total-divider"
                              }
                            />
                          )}
                        </div>
                      </Col>
                      <Col md={3} sm={24} xl={3} xxl={3} lg={3} xs={24}>
                        <div
                          className={
                            media === "sm" || media === "xs"
                              ? "flex flex-col"
                              : "flex"
                          }
                        >
                          <h1
                            className={
                              media === "sm" || media === "xs"
                                ? "text-[14px] pr-4 mb-[-8px] mt-[-8px] flex flex-center font-semibold"
                                : "text-[14px] pr-4 text-end font-semibold"
                            }
                          >
                            <div className="flex">
                              <p>₹</p>
                              <h1 className="ml-1 purchase-label text-[14px] mt-[1px]">
                                {itemSelectedRows &&
                                itemSelectedRows.length > 0 &&
                                taxableAmount
                                  ? parseFloat(taxableAmount).toFixed(2)
                                  : 0}
                              </h1>
                            </div>
                          </h1>
                          {media === "sm" || media === "xs" ? (
                            <Divider
                              type={"horizontal"}
                              className="h-[0px] w-[107%] ml-[-20px]"
                            />
                          ) : (
                            <Divider
                              type={"vertical"}
                              className={
                                media === "md"
                                  ? "h-[50px] total-divider"
                                  : "h-[40px] total-divider"
                              }
                            />
                          )}
                        </div>
                      </Col>
                      <Col md={3} sm={24} xl={3} xxl={3} lg={3} xs={24}>
                        <h1
                          className={
                            media === "sm" || media === "xs"
                              ? "text-[14px] pr-2 mt-[-8px] flex flex-center font-semibold"
                              : "text-[14px] pr-2 font-semibold"
                          }
                        >
                          <div className="flex">
                            <p>₹</p>
                            <h1 className="ml-1 purchase-label text-[14px] mt-[1px]">
                              {itemSelectedRows && itemSelectedRows.length > 0
                                ? parseFloat(totals.totalAmount).toFixed(2)
                                : 0}
                            </h1>
                          </div>
                        </h1>
                      </Col>
                    </Row>
                    {/* Add notes, total section */}
                    <Row className="border border-x-0 border-t-0 border-b-1">
                      {media === "sm" || media === "xs" ? (
                        ""
                      ) : (
                        <Col
                          span={12}
                          className="border border-r-1 border-l-0 border-y-0"
                        >
                          <div className="p-6"></div>
                        </Col>
                      )}
                      <Col
                        md={12}
                        sm={24}
                        lg={12}
                        xs={24}
                        className="border border-r-1 border-l-0 border-y-0"
                      >
                        {/* Total , after gst section */}
                        <div className="p-6 border border-x-0 border-b-1 border-t-0">
                          {additionalChargesOpen === true ? (
                            <div className="w-[100%] flex mt-3">
                              <Input
                                name="chargesData"
                                value={totalSectionData.chargesData}
                                placeholder="Enter charge(eg: transport charge)"
                                onChange={(e) => handleExpenseChange(e)}
                                className="w-[70%] pr-2 h-[40px] bg-[#e9ecf1] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1]"
                              />
                              <Input
                                name="additionalCharges"
                                value={totalSectionData.additionalCharges}
                                onChange={(e) => handleExpenseChange(e)}
                                addonAfter={
                                  <Select
                                    value={additionalOptions}
                                    onChange={(e) => setAdditionalOptions(e)}
                                    style={{
                                      width: 100,
                                      height: 25,
                                    }}
                                    defaultValue={"No Tax Applicable"}
                                    options={[
                                      {
                                        value: "No Tax Applicable",
                                        label: "No Tax Applicable",
                                      },
                                    ]}
                                  />
                                }
                                type="text"
                                prefix={"₹ "}
                                placeholder="0"
                                className="w-[70%] pr-3 h-[25px]"
                              />
                              <CloseCircleOutlined
                                className="w-[10%] pl-3"
                                onClick={() => setAdditionalChargesOpen(false)}
                              />
                            </div>
                          ) : (
                            <div
                              onClick={() => setAdditionalChargesOpen(true)}
                              className="flex justify-between mb-4 text-[#488dff] cursor-pointer"
                            >
                              <div>
                                <PlusOutlined /> Add Additional Charges
                              </div>
                              <div>
                                <h1>
                                  ₹.{" "}
                                  {totalSectionData.additionalCharges
                                    ? totalSectionData.additionalCharges
                                    : 0}
                                </h1>
                              </div>
                            </div>
                          )}
                          <div
                            // onClick={() => setAdditionalChargesOpen(true)}
                            className="mt-4  flex justify-between mb-3 cursor-pointer"
                          >
                            <h1 className="text-[14px] purchase-label">
                              Taxable Amount
                            </h1>
                            <p className="text-[14px] font-semibold">
                              ₹{" "}
                              {taxableAmount && taxableAmount !== undefined
                                ? parseFloat(taxableAmount)
                                    .toFixed(2)
                                    .toLocaleString("en-IN")
                                : 0}
                            </p>
                          </div>
                          {discountOpen === true ? (
                            <div className="w-[100%] flex mt-4">
                              <div className="w-[50%]">Discount</div>
                              <Input
                                name="discountPercent"
                                value={discountPercent}
                                onChange={(e) => {
                                  setDiscountPercent(e.target.value);

                                  const listData = e.target.value
                                    ? parseFloat(
                                        (e.target.value * netAmount) / 100
                                      ).toFixed(2)
                                    : 0;

                                  setDiscountAmount(listData);
                                }}
                                type="text"
                                prefix={"% "}
                                placeholder="0"
                                className=" w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[20px]"
                              />
                              <p className="pr-2 pl-2 text-[16px] pt-2">
                                {" / "}
                              </p>
                              <Input
                                name="discountAmount"
                                value={discountAmount}
                                onChange={(e) => {
                                  setDiscountAmount(e.target.value);

                                  const listData = e.target.value
                                    ? parseFloat(
                                        (e.target.value * 100) / netAmount
                                      ).toFixed(2)
                                    : 0;
                                  // const discountPercentValue = expenseData.totalAmount - listData
                                  // console.log(listData, "listData");
                                  setDiscountPercent(listData);
                                }}
                                type="text"
                                prefix={"₹ "}
                                placeholder="0"
                                className="w-[40%] focus:bg-[#e9ecf1] hover:bg-[#e9ecf1] bg-[#e9ecf1] mr-2 h-[20px]"
                              />
                              <CloseCircleOutlined
                                className="w-[15%] pl-5"
                                onClick={() => setDiscountOpen(false)}
                              />
                            </div>
                          ) : (
                            <div className="flex justify-between mb-3 text-[#488dff] cursor-pointer">
                              <div onClick={() => setDiscountOpen(true)}>
                                <PlusOutlined /> Add Discount
                              </div>
                              <div>
                                <h1>
                                  -₹.{" "}
                                  {itemSelectedRows &&
                                  itemSelectedRows.length > 0 &&
                                  totals.discountPrice
                                    ? parseFloat(totals.discountPrice).toFixed(
                                        2
                                      )
                                    : // : itemSelectedRows.length > 1
                                      // ? discountPriceTotal
                                      0}
                                </h1>
                              </div>
                            </div>
                          )}
                          <Divider
                            style={{
                              // borderWidth: "0.1px",
                              width:
                                media === "sm" || media === "xs"
                                  ? "109%"
                                  : "110%",
                              marginLeft: "-24px",
                            }}
                          />
                          <div
                            // onClick={() => setAdditionalChargesOpen(true)}
                            className="mt-4 pt-2 pb-2 flex justify-between mb-3 cursor-pointer"
                          >
                            <h1 className="text-[14px] expense-label">
                              Total Amount
                            </h1>
                            <p className="text-[14px] font-semibold">
                              ₹{" "}
                              {itemSelectedRows && itemSelectedRows.length > 0
                                ? netAmount.toFixed(2)
                                : 0}
                            </p>
                          </div>
                        </div>
                      </Col>
                    </Row>
                  </>
                ) : (
                  <Row
                    className={
                      media === "xs"
                        ? "w-[100%] flex flex-col bg-gray-50 p-1 border border-x-0 pl-5 pr-5 mt-3"
                        : "w-[100%] bg-gray-50 p-1 border border-x-0 pl-5 pr-5 mt-3"
                    }
                  >
                    <Col
                      md={17}
                      sm={24}
                      lg={17}
                      xs={24}
                      className={
                        media === "xs"
                          ? "flex justify-center"
                          : "flex justify-end"
                      }
                    >
                      <div className="flex">
                        <h1
                          className={
                            media === "xs"
                              ? "text-[14px] pr-2 mt-3 text-center purchase-label font-semibold"
                              : "text-[14px] pr-2 mt-3 text-end purchase-label font-semibold"
                          }
                        >
                          Total
                        </h1>
                        {media === "xs" ? (
                          ""
                        ) : (
                          <Divider
                            type="vertical"
                            className="total-expense-divider"
                          />
                        )}
                      </div>
                    </Col>
                    <Col
                      md={7}
                      sm={24}
                      lg={7}
                      xs={24}
                      className={
                        media === "xs"
                          ? "pr-3 flex justify-center"
                          : "pr-3 flex justify-end"
                      }
                    >
                      <Input
                        name="totalAmount"
                        value={expenseData.totalAmount}
                        onChange={(e) => handleChange(e)}
                        placeholder="0"
                        // disabled
                        className="w-[60%] p-1 text-end"
                        addonBefore={"₹ "}
                      />
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </Col>
        </div>

        {/* Category modal */}
        <Modal
          open={addCategoryModal}
          title="Add / Manage Category"
          onOk={() => setAddCategoryModal(false)}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          width={600}
          className="mt-[-70px]"
          onCancel={() => setAddCategoryModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div
              style={{
                display: "none",
              }}
            >
              <CancelBtn />
              <OkBtn />
            </div>
          )}
        >
          <Divider
            style={{ borderWidth: "0.2px", width: "108%", marginLeft: "-24px" }}
          />
          <Col span={24} className="mt-5">
            {categoryOptions.map((data, index) => {
              return (
                <div key={index}>
                  <div className="mb-2 mt-6 flex justify-between">
                    <h1
                      style={{
                        fontFamily: "Poppins",
                        fontSize: "12px",
                      }}
                    >
                      {data.label}
                    </h1>
                    <div className="flex">
                      <div
                        onClick={() => {
                          setNewExpenseCategory(true);
                          setNewExpenseMode("Edit");
                          setExpenseCategory({
                            ...expenseCategory,
                            expenseName: data.label,
                            _id: data.value,
                          });
                        }}
                        className="text-[12px] flex border mb-2 rounded-md p-2 cursor-pointer"
                      >
                        <EditOutlined className="text-[16px] mr-2" />
                        Edit
                      </div>
                      <div
                        onClick={() => {
                          setDeleteCategory(true);
                          setExpenseCategory({
                            ...expenseCategory,
                            _id: data.value,
                          });
                        }}
                        className="text-[12px] ml-2 border mb-2 rounded-md p-2 cursor-pointer"
                      >
                        <DeleteOutlined className="text-[16px] text-[#dc3545]" />
                      </div>
                    </div>
                  </div>
                  <Divider
                    style={{
                      width: "109%",
                      marginTop: "-5px",
                      marginBottom: "-5px",
                      marginLeft: "-24px",
                    }}
                  />
                </div>
              );
            })}
          </Col>
          <Col span={24} className="mt-5">
            <div
              onClick={() => {
                setNewExpenseCategory(true);
                setNewExpenseMode("Add");
                setExpenseCategory({
                  ...expenseCategory,
                  _id: "",
                  expenseName: "",
                });
              }}
              style={{
                fontFamily: "Poppins",
              }}
              className="cursor-pointer w-[100%] rounded-md text-center p-2 border border-dashed border-blue-400 border-2 text-blue-400  mb-2"
            >
              + New Expense Category
            </div>
          </Col>
        </Modal>

        {/* New Expense modal */}
        <Modal
          open={newExpenseCategory}
          title={
            newExpenseMode === "Edit"
              ? `Edit ${expenseCategory.expenseName}`
              : "Create New Category"
          }
          onOk={newExpenseMode === "Edit" ? updateCategoryApi : addCategoryApi}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          okButtonProps={{
            disabled: isCategoryButtonDisabled ? true : false,
          }}
          width={450}
          onCancel={() => setAddCategoryModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.2px",
              marginTop: "3px",
              width: "112%",
              marginLeft: "-24px",
            }}
          />
          <Col span={24} className="mb-[50px]">
            <Typography
              className="uppercase mb-1"
              style={{
                fontFamily: "Poppins",
                fontSize: "12px",
              }}
            >
              Category Name
            </Typography>
            <Input
              name="expenseName"
              value={expenseCategory.expenseName}
              onChange={(e) => handleExpenseCategoryChange(e)}
              placeholder="Enter Category Name"
              className="p-2"
            />
          </Col>
        </Modal>

        <Modal
          open={deleteCategory}
          onOk={() => deleteCategoryApi()}
          closeIcon
          maskClosable={false}
          rootClassName="p-15 h-[300px]"
          okText={"Yes, Delete"}
          cancelText={"Cancel"}
          okButtonProps={{
            disabled: isDeleteButtonDisabled ? true : false,
          }}
          okType="danger"
          onCancel={() => setDeleteCategory(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <CancelBtn />
              <div className="ml-2">
                <OkBtn />
              </div>
            </div>
          )}
          width={450}
        >
          <div className="text-center p-3 w-[100%]">
            <DeleteOutlined className="mb-2 text-center text-[#dc3545] font-bold text-[44px]" />
            <h1
              style={{
                fontFamily: "Poppins",
              }}
              className="text-center text-[18px] font-bold"
            >
              Delete Expense Category?
            </h1>
            <p
              style={{
                fontFamily: "Poppins",
              }}
              className="text-center text-[14px] text-[#8b8b8b] mt-2"
            >
              Are you sure you want to delete this expense category? Deleted
              category cannot be retrieved
            </p>
          </div>
        </Modal>

        {/* Create item modal */}

        {/* item create Modal */}
        <Modal
          open={itemModal}
          title="Add Expense Items"
          onOk={() => setItemModal(false)}
          closeIcon
          maskClosable={false}
          okText={"Done"}
          width={"80%"}
          style={{
            fontFamily: "Poppins",
          }}
          className="mt-[-40px]"
          onCancel={() => setItemModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider className="purchase-divider" />
          <Col span={24} className="mt-[-10px]">
            <Row>
              <Col span={24} className="pr-3 flex justify-between">
                <AutoComplete
                  style={{
                    width: 170,
                    marginRight: "10px",

                    fontFamily: "Poppins",
                  }}
                >
                  <Input.Search
                    size="large"
                    placeholder="Search Item"
                    style={{
                      fontFamily: "Poppins",
                    }}
                    name="itemSearch"
                    value={itemSearch}
                    onChange={(e) => handleItemSearch(e)}
                  />
                </AutoComplete>
                <div
                  style={{
                    fontFamily: "Poppins",
                  }}
                  onClick={() => {
                    setCreateItemModal(true);
                    setNewItemData({
                      itemName: "",
                      purchasePrice: "",
                      hsnCode: "",
                      _id: "",
                    });
                    setItemType("");
                    setItcApplicable([]);
                    setMeasuringUnit([]);
                    setGstRate([]);
                    setItcApplicable([]);
                    setPurchaseMode("Without Tax");
                  }}
                  className="border text-[#1677ff] border-blue-400 text-center  rounded-md pl-8 pr-8 p-2 cursor-pointer"
                >
                  <PlusOutlined className="mr-1" /> Create New Item
                </div>
              </Col>
              {/* <Col span={10}>
                {" "}
              </Col> */}
            </Row>
            <Row>
              <Col
                span={24}
                className={
                  itemsDataTable.length > 0
                    ? "add-create-item-expense-main mt-3"
                    : "h-[120px] mt-3"
                }
              >
                <table className=" table-purchase-serial table-responsive">
                  <thead>
                    <tr>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Item Name
                      </th>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Item Code
                      </th>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Purchase Price
                      </th>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Current Stock
                      </th>
                      <th className="table-purchase-head uppercase text-[12px] font-medium">
                        Action
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {itemRows &&
                    itemRows.length > 0 &&
                    expenses_item_list.length > 0 ? (
                      itemRows.map((data, index) => {
                        const quantitySelected =
                          itemSelectedRows &&
                          itemSelectedRows.length >= 1 &&
                          itemSelectedRows[0].itemName &&
                          itemSelectedRows.find((item) => item._id == data._id);

                        data.quantityCount =
                          !isEmpty(quantitySelected) &&
                          quantitySelected.quantityCount
                            ? quantitySelected.quantityCount
                            : data.quantityCount;
                        return (
                          <tr key={index} className="table-purchase-orders-row">
                            <td
                              className="table-purchase-data flex"
                              // onClick={() => setExpandable(true)}
                            >
                              <Checkbox
                                type="checkbox"
                                name="itemChecked"
                                height={14}
                                width={14}
                                // defaultChecked
                                checked={
                                  // !!selectedItem
                                  data.quantityCount !== 0 ||
                                  itemSelectedRows.some(
                                    (selected) => selected._id == data._id
                                  )
                                }
                                value={data.itemChecked}
                                // onChange={(e) =>
                                //   handleCheckboxChange(data, e.target.checked)
                                // }
                                onChange={(e) =>
                                  handleItemChange(
                                    e,
                                    "itemChecked",
                                    index,
                                    data
                                  )
                                }
                                className="mr-2 mt-2 text-[#084d7b]"
                              />
                              <p className="mt-3">{data.itemName}</p>
                            </td>
                            <td className="table-purchase-data">
                              {data.hsnCode}
                            </td>
                            <td className="table-purchase-data">
                              {data.purchasePrice}
                            </td>

                            <td className="table-purchase-data">
                              {/* {data.stockQTY && data.stockQTY > 1 && ( */}
                              <div className="w-[100%] flex justify-between border border-1 text-center rounded-md p-1 cursor-pointer">
                                <div className="flex">
                                  <p
                                    onClick={() => {
                                      // setQuantityCountValue(
                                      //   quantityCountValue - 1
                                      // );

                                      // setItemRows((prevRows)=> {
                                      //   prevRows.map((row)=> {
                                      //    if(data._id === row._id) {
                                      //      return {
                                      //        ...row,
                                      //        quantityCount: row.quantityCount - 1
                                      //      }
                                      //    }
                                      //   })

                                      //  })
                                      data.quantityCount = parseInt(
                                        data.quantityCount - 1
                                      );

                                      let newSelecteds = [];
                                      // if (data.quantityCount >= 1) {
                                      // const selectedIndex =
                                      // data.quantityCount == 1 && itemSelectedRows.indexOf(data);
                                      // if (selectedIndex === -1) {
                                      newSelecteds =
                                        data.quantityCount < 1
                                          ? itemSelectedRows.filter(
                                              (item) => item._id !== data._id
                                            )
                                          : data.quantityCount >= 1 &&
                                            newSelecteds.concat(
                                              itemSelectedRows,
                                              data
                                            );

                                      const itemSelectedFilteredRows =
                                        newSelecteds && newSelecteds.length > 0
                                          ? newSelecteds.filter(
                                              (data) => !isEmpty(data.itemName)
                                            )
                                          : [];

                                      const itemSelectedArrays =
                                        newSelecteds &&
                                        itemSelectedFilteredRows &&
                                        itemSelectedFilteredRows.length > 0
                                          ? itemSelectedFilteredRows.map(
                                              (item) => {
                                                // const gstPercentage =
                                                //   item.taxPercentageName
                                                //     ? item.taxPercentageName
                                                //     : "";
                                                const quantityCount =
                                                  data.quantityCount;
                                                const gstRateName =
                                                  item.taxPercentageValue !==
                                                  undefined
                                                    ? item.taxPercentageValue
                                                    : item.taxPercentageName ==
                                                        "None" ||
                                                      item.taxPercentageName ==
                                                        "Exempted"
                                                    ? 0
                                                    : "";
                                                // const quantityCount = item.quantityCount;
                                                const totalPriceData =
                                                  !isUndefined(quantityCount) &&
                                                  item.purchasePrice
                                                    ? quantityCount *
                                                      item.purchasePrice
                                                    : 0;

                                                const percentageValue =
                                                  parseFloat(
                                                    totalPriceData *
                                                      item.taxPercentageValue
                                                  );
                                                const gstInclusion =
                                                  Number(100) +
                                                  Number(
                                                    item.taxPercentageValue
                                                  );

                                                const taxPriceData =
                                                  item.taxPercentageValue !==
                                                    undefined &&
                                                  item.isWithoutTax == true
                                                    ? parseFloat(
                                                        percentageValue / 100
                                                      )
                                                    : item.taxPercentageValue !==
                                                        undefined &&
                                                      item.isWithTax == true
                                                    ? Number(percentageValue) /
                                                      Number(
                                                        gstInclusion
                                                      ).toFixed(2)
                                                    : "";
                                                const purchasePrice =
                                                  item.isWithTax == true &&
                                                  expenseWithGst === true
                                                    ? parseFloat(
                                                        quantityCount *
                                                          item.purchasePriceValue -
                                                          taxPriceData
                                                      )
                                                    : item.isWithoutTax ==
                                                        true &&
                                                      expenseWithGst === true
                                                    ? item.purchasePrice
                                                    : item.purchasePrice;
                                                // const withTaxSetAmount =
                                                // purchasePrice +
                                                //     taxPriceData

                                                const totalSetAmountData =
                                                  expenseWithGst == true &&
                                                  taxPriceData !== undefined &&
                                                  item.isWithoutTax == true
                                                    ? parseFloat(
                                                        totalPriceData +
                                                          taxPriceData
                                                      )
                                                    : expenseWithGst == true &&
                                                      item.isWithTax == true &&
                                                      taxPriceData !== undefined
                                                    ? Number(purchasePrice) +
                                                      Number(taxPriceData)
                                                    : totalPriceData;
                                                const discountPriceValue =
                                                  item.discountPrice
                                                    ? parseFloat(
                                                        totalSetAmountData -
                                                          item.discountPrice
                                                      )
                                                    : totalSetAmountData;
                                                const totalPrice =
                                                  discountPriceValue;

                                                return {
                                                  // index: index + 1,
                                                  itemName: item.itemName,
                                                  itemNameValue: item.itemName,
                                                  itemChecked:
                                                    data.quantityCount < 1
                                                      ? false
                                                      : true,
                                                  _id: item._id,
                                                  itemCode: item.hsnCode
                                                    ? item.hsnCode
                                                    : "--",
                                                  salesPrice: item.salesPrice
                                                    ? item.salesPrice
                                                    : "",
                                                  purchasePrice:
                                                    item.purchasePrice
                                                      ? parseFloat(
                                                          purchasePrice
                                                        ).toFixed(2)
                                                      : "",
                                                  createdAt: item.createdAt
                                                    ? item.createdAt
                                                    : "",
                                                  createdBy: item.createdBy
                                                    ? item.createdBy
                                                    : "",
                                                  categoryId: item.categoryId
                                                    ? item.categoryId
                                                    : "",
                                                  categoryName:
                                                    item.categoryName
                                                      ? item.categoryName
                                                      : "",
                                                  isWithTax: item.isWithTax
                                                    ? item.isWithTax
                                                    : "",
                                                  isWithoutTax:
                                                    item.isWithoutTax
                                                      ? item.isWithoutTax
                                                      : "",
                                                  categoryNameValue:
                                                    item.categoryName
                                                      ? item.categoryName
                                                      : "",
                                                  taxPercentageId:
                                                    item.taxPercentageId
                                                      ? item.taxPercentageId
                                                      : "",
                                                  taxPercentageName:
                                                    item.taxPercentageName
                                                      ? item.taxPercentageName
                                                      : "",
                                                  taxPercentage:
                                                    item.taxPercentage
                                                      ? item.taxPercentage
                                                      : "",
                                                  taxValue:
                                                    taxPriceData !== "" &&
                                                    expenseWithGst === true
                                                      ? taxPriceData
                                                      : item.taxValue
                                                      ? item.taxValue
                                                      : "",
                                                  taxPercentageValue:
                                                    item.taxPercentageName !==
                                                      undefined &&
                                                    expenseWithGst === true
                                                      ? gstRateName
                                                      : item.taxPercentageValue,
                                                  itemCodeValue: item.hsnCode
                                                    ? item.hsnCode
                                                    : "",
                                                  salesPriceValue:
                                                    item.salesPrice
                                                      ? item.salesPrice
                                                      : "",
                                                  purchasePriceValue:
                                                    item.purchasePrice
                                                      ? item.purchasePriceValue
                                                      : "",
                                                  discountPrice: !isUndefined(
                                                    item.discountPrice
                                                  )
                                                    ? item.discountPrice
                                                    : 0,
                                                  discountPercentage:
                                                    !isUndefined(
                                                      item.discountPercentage
                                                    )
                                                      ? item.discountPercentage
                                                      : 0,
                                                  totalAmount: totalPrice,
                                                  quantityCount:
                                                    item.quantityCount
                                                      ? item.quantityCount
                                                      : 1,
                                                  categoryIdValue:
                                                    item.categoryId
                                                      ? item.categoryId
                                                      : "",
                                                  hsnCode: item.hsnCode
                                                    ? item.hsnCode
                                                    : "",
                                                  // descriptionValue: item.description,
                                                  isProduct: item.isProduct
                                                    ? item.isProduct
                                                    : "",
                                                  isService: item.isService
                                                    ? item.isService
                                                    : "",
                                                  measuringId: item.measuringId
                                                    ? item.measuringId
                                                    : "",
                                                  description: item.description
                                                    ? item.description
                                                    : "",
                                                  // serialDetails: item.serialDetails,
                                                  updatedAt: item.updatedAt
                                                    ? item.updatedAt
                                                    : "",
                                                  status: item.status
                                                    ? item.status
                                                    : "",
                                                };
                                              }
                                            )
                                          : [];

                                      const filteredData = Object.values(
                                        itemSelectedArrays.reduce(
                                          (acc, item) => {
                                            if (
                                              !acc[item._id] ||
                                              acc[item._id].quantityCount >
                                                item.quantityCount
                                            ) {
                                              acc[item._id] = item;
                                            }
                                            // }
                                            return acc;
                                          },
                                          {}
                                        )
                                      );
                                      setItemSelectedRows(filteredData);
                                      // }

                                      // data.quantityCount > 1 &&
                                      // handleQuantityChange(data._id, parseInt(data.quantityCount - 1))

                                      setPageRender(!pageRender);
                                    }}
                                    className={
                                      // data.itemChecked === false
                                      //   ? "pointer-events-none opacity-1 pl-3 pr-3 p-1 rounded-md bg-[#488dff] text-[#ffffff]"
                                      //   :
                                      "pl-3 pr-3 p-1 rounded-md bg-[#488dff] text-[#ffffff]"
                                    }
                                  >
                                    <h1 className="text-[15px] purchase-label font-semibold">
                                      -
                                    </h1>
                                  </p>
                                  <h1 className="text-[14px] font-semibold purchase-label pt-1 pr-3 pl-3">
                                    {data.quantityCount && data.quantityCount}
                                  </h1>
                                  <p
                                    onClick={() => {
                                      data.quantityCount = parseInt(
                                        data.quantityCount + 1
                                      );

                                      let newSelecteds = [];
                                      if (data.quantityCount >= 1) {
                                        newSelecteds =
                                          data.quantityCount >= 1 &&
                                          newSelecteds.concat(
                                            itemSelectedRows,
                                            data
                                          );
                                        const itemSelectedFilteredRows =
                                          newSelecteds &&
                                          newSelecteds.length > 0
                                            ? newSelecteds.filter(
                                                (data) =>
                                                  !isEmpty(data.itemName)
                                              )
                                            : [];
                                        const itemSelectedArrays =
                                          newSelecteds &&
                                          itemSelectedFilteredRows &&
                                          itemSelectedFilteredRows.length > 0
                                            ? itemSelectedFilteredRows.map(
                                                (item) => {
                                                  const quantityCount =
                                                    data.quantityCount;
                                                  const gstRateName =
                                                    item.taxPercentageValue !==
                                                    undefined
                                                      ? item.taxPercentageValue
                                                      : item.taxPercentageName ==
                                                          "None" ||
                                                        item.taxPercentageName ==
                                                          "Exempted"
                                                      ? 0
                                                      : "";
                                                  // const quantityCount = item.quantityCount;
                                                  const totalPriceData =
                                                    !isUndefined(
                                                      quantityCount
                                                    ) && item.purchasePrice
                                                      ? quantityCount *
                                                        item.purchasePrice
                                                      : 0;

                                                  const percentageValue =
                                                    parseFloat(
                                                      totalPriceData *
                                                        item.taxPercentageValue
                                                    );
                                                  const gstInclusion =
                                                    Number(100) +
                                                    Number(
                                                      item.taxPercentageValue
                                                    );

                                                  const taxPriceData =
                                                    item.taxPercentageValue !==
                                                      undefined &&
                                                    item.isWithoutTax == true
                                                      ? parseFloat(
                                                          percentageValue / 100
                                                        )
                                                      : item.taxPercentageValue !==
                                                          undefined &&
                                                        item.isWithTax == true
                                                      ? Number(
                                                          percentageValue
                                                        ) /
                                                        Number(
                                                          gstInclusion
                                                        ).toFixed(2)
                                                      : "";
                                                  const purchasePrice =
                                                    item.isWithTax == true &&
                                                    expenseWithGst === true
                                                      ? parseFloat(
                                                          quantityCount *
                                                            item.purchasePriceValue -
                                                            taxPriceData
                                                        )
                                                      : item.isWithoutTax ==
                                                          true &&
                                                        expenseWithGst === true
                                                      ? item.purchasePrice
                                                      : item.purchasePrice;
                                                  // const withTaxSetAmount =
                                                  // purchasePrice +
                                                  //     taxPriceData

                                                  const totalSetAmountData =
                                                    expenseWithGst == true &&
                                                    taxPriceData !==
                                                      undefined &&
                                                    item.isWithoutTax == true
                                                      ? parseFloat(
                                                          totalPriceData +
                                                            taxPriceData
                                                        )
                                                      : expenseWithGst ==
                                                          true &&
                                                        item.isWithTax ==
                                                          true &&
                                                        taxPriceData !==
                                                          undefined
                                                      ? Number(purchasePrice) +
                                                        Number(taxPriceData)
                                                      : totalPriceData;
                                                  const discountPriceValue =
                                                    item.discountPrice
                                                      ? parseFloat(
                                                          totalSetAmountData -
                                                            item.discountPrice
                                                        )
                                                      : totalSetAmountData;
                                                  const totalPrice =
                                                    discountPriceValue;
                                                  return {
                                                    // index: index + 1,
                                                    itemName: item.itemName,
                                                    itemNameValue:
                                                      item.itemName,
                                                    itemChecked: true,
                                                    _id: item._id,
                                                    itemCode: item.hsnCode
                                                      ? item.hsnCode
                                                      : "--",
                                                    salesPrice: item.salesPrice
                                                      ? item.salesPrice
                                                      : "",
                                                    purchasePrice:
                                                      item.purchasePrice
                                                        ? parseFloat(
                                                            purchasePrice
                                                          ).toFixed(2)
                                                        : "",
                                                    createdAt: item.createdAt
                                                      ? item.createdAt
                                                      : "",
                                                    createdBy: item.createdBy
                                                      ? item.createdBy
                                                      : "",
                                                    categoryId: item.categoryId
                                                      ? item.categoryId
                                                      : "",
                                                    categoryName:
                                                      item.categoryName
                                                        ? item.categoryName
                                                        : "",
                                                    isWithTax: item.isWithTax
                                                      ? item.isWithTax
                                                      : "",
                                                    isWithoutTax:
                                                      item.isWithoutTax
                                                        ? item.isWithoutTax
                                                        : "",
                                                    categoryNameValue:
                                                      item.categoryName
                                                        ? item.categoryName
                                                        : "",
                                                    taxPercentageId:
                                                      item.taxPercentageId
                                                        ? item.taxPercentageId
                                                        : "",
                                                    taxPercentageName:
                                                      item.taxPercentageName
                                                        ? item.taxPercentageName
                                                        : "",
                                                    taxPercentage:
                                                      item.taxPercentage
                                                        ? item.taxPercentage
                                                        : "",
                                                    taxValue:
                                                      taxPriceData !== "" &&
                                                      expenseWithGst === true
                                                        ? taxPriceData
                                                        : item.taxValue
                                                        ? item.taxValue
                                                        : "",
                                                    taxPercentageValue:
                                                      item.taxPercentageName !==
                                                        undefined &&
                                                      expenseWithGst === true
                                                        ? gstRateName
                                                        : item.taxPercentageValue,
                                                    itemCodeValue: item.hsnCode
                                                      ? item.hsnCode
                                                      : "",
                                                    salesPriceValue:
                                                      item.salesPrice
                                                        ? item.salesPrice
                                                        : "",
                                                    purchasePriceValue:
                                                      item.purchasePrice
                                                        ? item.purchasePriceValue
                                                        : "",
                                                    discountPrice: !isUndefined(
                                                      item.discountPrice
                                                    )
                                                      ? item.discountPrice
                                                      : 0,
                                                    discountPercentage:
                                                      !isUndefined(
                                                        item.discountPercentage
                                                      )
                                                        ? item.discountPercentage
                                                        : 0,
                                                    totalAmount: totalPrice,
                                                    quantityCount:
                                                      item.quantityCount
                                                        ? item.quantityCount
                                                        : 1,
                                                    categoryIdValue:
                                                      item.categoryId
                                                        ? item.categoryId
                                                        : "",
                                                    hsnCode: item.hsnCode
                                                      ? item.hsnCode
                                                      : "",
                                                    // descriptionValue: item.description,
                                                    isProduct: item.isProduct
                                                      ? item.isProduct
                                                      : "",
                                                    isService: item.isService
                                                      ? item.isService
                                                      : "",
                                                    measuringId:
                                                      item.measuringId
                                                        ? item.measuringId
                                                        : "",
                                                    description:
                                                      item.description
                                                        ? item.description
                                                        : "",
                                                    // serialDetails: item.serialDetails,
                                                    updatedAt: item.updatedAt
                                                      ? item.updatedAt
                                                      : "",
                                                    status: item.status
                                                      ? item.status
                                                      : "",
                                                  };
                                                }
                                              )
                                            : [];

                                        const filteredData = Object.values(
                                          itemSelectedArrays.reduce(
                                            (acc, item) => {
                                              if (
                                                !acc[item._id] ||
                                                acc[item._id].quantityCount <
                                                  item.quantityCount
                                              ) {
                                                acc[item._id] = item;
                                              }
                                              return acc;
                                            },
                                            {}
                                          )
                                        );

                                        setItemSelectedRows(filteredData);
                                      }
                                      setPageRender(!pageRender);
                                    }}
                                    className={
                                      "pl-3 pr-3 p-1 rounded-md bg-[#488dff] text-[#ffffff]"
                                    }
                                  >
                                    <h1 className="text-[15px] purchase-label font-semibold">
                                      +
                                    </h1>
                                  </p>
                                </div>
                                <div className="bg-[#f8f9fc] border border-r-0 border-y-0 border-l-2 p-1 pl-4 pr-4">
                                  <h1 className="pl-2">{data.quantityCount}</h1>
                                </div>
                                {/* <PlusOutlined className="mr-1" /> Add */}
                              </div>
                              {/* )} */}
                            </td>
                            <td className="table-expense-data">
                              <Popover
                                placement="bottom"
                                trigger={"click"}
                                content={
                                  <div className="hover:rounded-md hover:mr-[-3px] w-[40px] h-[55px] mt-[-12px] pl-3 pr-2 pt-2 pb-2 cursor-pointer">
                                    <div className="">
                                      <p
                                        onClick={() => {
                                          setNewItemData({
                                            ...newItemData,
                                            purchasePrice: data.purchasePrice,
                                            hsnCode: data.hsnCode,
                                            itemName: data.itemName,
                                            _id: data._id,
                                            gstRate: data.gstrateId,
                                            itcApplicable: data.itcStatusId,
                                            measuringUnit: data.measuringUnitId,
                                          });
                                          setGstRate({
                                            label: data.gstrateName,
                                            value: data.gstrateId,
                                          });
                                          setCreateItemModal(true);
                                          setItemType(
                                            data.isProduct === true
                                              ? "Product"
                                              : "Service"
                                          );
                                          setPurchaseMode(
                                            data.isWithTax === true
                                              ? "With Tax"
                                              : "Without Tax"
                                          );
                                          setItcApplicable(
                                            data.itcApplicableName
                                          );
                                          setMeasuringUnit(
                                            data.measuringUnitName
                                          );
                                        }}
                                      >
                                        <EditOutlined className="text-[18px] font-bold text-[#35a935]" />
                                      </p>
                                    </div>
                                    <div className="mb-[-6px] mt-2">
                                      <p
                                        onClick={() => {
                                          setNewItemData({
                                            ...newItemData,
                                            _id: data._id,
                                          });
                                          setDeleteExpenseItem(true);
                                        }}
                                      >
                                        <DeleteOutlined className="text-[18px] font-bold text-[#db1113]" />
                                      </p>
                                    </div>
                                  </div>
                                }
                              >
                                <div className="cursor-pointer w-[40px] border border-1 rounded-md p-2">
                                  <UnorderedListOutlined className="text-[16px]" />
                                </div>
                              </Popover>
                            </td>
                          </tr>
                        );
                      })
                    ) : (
                      <tr key={0} className="table-purchase-orders-row">
                        <td
                          style={{
                            fontFamily: "Poppins",
                          }}
                          colSpan={8}
                          className="text-center p-3"
                        >
                          No Data found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </Col>
            </Row>
          </Col>

          <Divider
            style={{
              borderWidth: "0.1px",
              width: "104.5%",
              marginLeft: "-24px",
            }}
          />
        </Modal>

        <Modal
          open={deleteExpenseItem}
          onOk={() => {
            deleteExpenseItemApi();
          }}
          closeIcon
          maskClosable={false}
          okText={`Delete Expense Item`}
          cancelText={"Cancel"}
          okType="danger"
          okButtonProps={{
            disabled: isExpenseButtonDisabled ? true : false,
          }}
          onCancel={() => setDeleteExpenseItem(false)}
          height={300}
          footer={(_, { OkBtn, CancelBtn }) => (
            <div className="text-center flex justify-center">
              <CancelBtn />
              <div className="ml-3">
                <OkBtn />
              </div>
            </div>
          )}
        >
          <div className="text-center w-[100%] p-7">
            <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
            <h1 className="text-center text-[18px] font-bold">
              Are you sure you want to delete these expense item?
            </h1>
            <p className="text-center text-[14px] mt-2">
              The selected expense will be deleted from the expense Inventory.
              Once deleted you will not be able to restore these expense.
            </p>
          </div>
        </Modal>

        {/* Settings fields modal */}
        <Modal
          open={purchasePriceModal}
          title="Quick Expense Settings"
          onOk={() => createPrefixSettings()}
          closeIcon
          maskClosable={false}
          okText={"Save"}
          okButtonProps={{
            disabled: isPrefixButtonDisabled ? true : false,
          }}
          onCancel={() => setPurchasePriceModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{ width: "110%", marginTop: "3px", marginLeft: "-24px" }}
          />
          <Col span={24}>
            <div className="w-[100%] flex justify-between mb-2 mt-[-15px]">
              <h1 className="purchase-label text-[16px]">
                Expense Prefix & Invoice Number
              </h1>
              <Switch
                value={invoiceShow}
                onChange={(checked) => setInvoiceShow(checked)}
              />
            </div>
            {invoiceShow ? (
              <Row className="mt-2">
                <Col span={8} className="pr-3">
                  <Typography className="mb-1">Prefix</Typography>

                  <Input
                    name="prefix"
                    value={expensePrefixData.prefix}
                    onChange={(e) => handleExpensePrefixChange(e)}
                    placeholder="Enter Prefix"
                    className="p-2"
                  />
                  {prefixValidations === true &&
                  invoiceShow &&
                  isEmpty(expensePrefixData.prefix) ? (
                    <p className="text-[red] text-[12px]">
                      The Prefix field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={8}>
                  <Typography className="mb-1">Sequence Number</Typography>

                  <Input
                    name="seqNo"
                    value={expensePrefixData.seqNo}
                    onChange={(e) => handleExpensePrefixChange(e)}
                    placeholder="Enter Seq No"
                    className="p-2"
                  />
                  {prefixValidations === true &&
                  invoiceShow &&
                  isEmpty(expensePrefixData.seqNo) ? (
                    <p className="text-[red] text-[12px]">
                      The seq no field is required
                    </p>
                  ) : (
                    ""
                  )}
                </Col>
                <Col span={24} className="mt-2">
                  <Typography className="mb-1">
                    Sales Invoice Number:{" "}
                    {expensePrefixData.prefix && expensePrefixData.seqNo
                      ? expensePrefixData.prefix + "" + expensePrefixData.seqNo
                      : ""}
                  </Typography>
                </Col>
              </Row>
            ) : (
              ""
            )}
          </Col>

          <Divider
            style={{
              marginTop: "3px",
              marginBottom: "-2px",
              width: "110%",
              marginLeft: "-24px",
            }}
          />
        </Modal>
        {/* Add batching Modal */}
        <Modal
          open={createItemModal}
          title={
            !isEmpty(newItemData._id)
              ? "Update New Expense Item"
              : "Create New Expense Item"
          }
          onOk={
            !isEmpty(newItemData._id)
              ? updateExpenseItemApi
              : createExpenseItemApi
          }
          closeIcon
          maskClosable={false}
          okButtonProps={{
            disabled: isExpenseButtonDisabled ? true : false,
          }}
          style={{
            fontFamily: "Poppins",
          }}
          okText={!isEmpty(newItemData._id) ? "Update" : "Save"}
          width={600}
          onCancel={() => setCreateItemModal(false)}
          footer={(_, { OkBtn, CancelBtn }) => (
            <>
              <CancelBtn />
              <OkBtn />
            </>
          )}
        >
          <Divider
            style={{
              borderWidth: "0.1px",
              width: "109%",
              marginLeft: "-24px",
              marginTop: "-1px",
            }}
          />
          <Col span={24}>
            <Row className="mt-3">
              <Col span={12} className="pr-4">
                <Typography className="text-[#667085] expense-label mb-1 flex">
                  Item Name
                  <p className="text-[red] text-[12px] ml-1">*</p>
                </Typography>

                <Input
                  placeholder={""}
                  className="p-2"
                  name="itemName"
                  value={newItemData.itemName}
                  onChange={(e) => handleNewItemChange(e)}
                />
                <p className="text-[red] mt-[2px] text-[12px]">
                  {createItemValidations && isEmpty(newItemData.itemName)
                    ? "The item name field is required"
                    : ""}
                </p>
              </Col>
              <Col span={12}>
                <Typography className="text-[#667085] expense-label flex">
                  Item Type
                  <p className="text-[red] text-[12px] ml-1">*</p>
                </Typography>
                <Radio.Group
                  className="flex pt-1"
                  value={itemType}
                  onChange={(e) => setItemType(e.target.value)}
                >
                  <div className="flex w-[45%] border border-1 rounded-md pt-1.5 pb-1.5 pl-2 pr-2">
                    <Typography
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="mb-1 mr-2"
                    >
                      {" "}
                      Product
                    </Typography>
                    <Radio value={"Product"}></Radio>
                  </div>
                  <div className="flex w-[45%] border border-1 rounded-md pt-1.5 pb-1.5 pl-2 pr-2 ml-[20px]">
                    <Typography
                      style={{
                        fontFamily: "Poppins",
                      }}
                      className="mb-1 mr-2"
                    >
                      {" "}
                      Service
                    </Typography>
                    <Radio value={"Service"}></Radio>
                  </div>
                </Radio.Group>
                <p className="text-[red] mt-[2px] text-[12px]">
                  {createItemValidations && isEmpty(itemType)
                    ? "The item type field is required"
                    : ""}
                </p>
              </Col>
            </Row>
            <Row className="mt-3">
              <Col span={12} className="pr-4">
                <Typography className="text-[#667085] expense-label mb-1 flex">
                  Purchase Price
                </Typography>

                <Input
                  name="purchasePrice"
                  value={newItemData.purchasePrice}
                  onChange={(e) => handleNewItemChange(e)}
                  addonAfter={
                    <Select
                      value={purchaseMode}
                      onChange={(e) => setPurchaseMode(e)}
                      style={{
                        width: "130px",
                        height: "45px",
                      }}
                      options={[
                        {
                          label: "With Tax",
                          value: "With Tax",
                        },
                        {
                          label: "Without Tax",
                          value: "Without Tax",
                        },
                      ]}
                    />
                  }
                  type="text"
                  prefix={"₹ "}
                  placeholder="ex: ₹100"
                />
              </Col>
              <Col span={12} className="pr-4">
                <Typography className="text-[#667085] expense-label mb-1">
                  Measuring Unit
                </Typography>
                <Select
                  placeholder="Select"
                  className="h-[40px] w-[100%]"
                  value={measuringUnit}
                  onChange={(e) => setMeasuringUnit(e)}
                  options={recordsMetaData ? recordsMetaData.unitOptions : []}
                />
              </Col>
              <Col span={12} className="pr-4 mt-3">
                <Typography className="text-[#667085] expense-label mb-1 flex">
                  {itemType === "Service" ? "SAC" : "HSN"}
                </Typography>

                <Input
                  name="hsnCode"
                  value={newItemData.hsnCode}
                  onChange={(e) => handleNewItemChange(e)}
                  placeholder={""}
                  className="p-2"
                />
              </Col>
              {purchaseMode === "With Tax" ? (
                <Col span={12} className="pr-4 mt-3">
                  <Typography className="text-[#667085] expense-label mb-1">
                    GST Tax Rate(%)
                  </Typography>
                  <Select
                    placeholder="Select Tax"
                    className="h-[40px] w-[100%]"
                    value={gstRate}
                    onChange={(e, option) =>
                      setGstRate({
                        label: option.label,
                        value: e,
                      })
                    }
                    options={
                      recordsMetaData
                        ? recordsMetaData.gstPercentageOptions
                        : []
                    }
                  />
                  <p className="text-[red] mt-[2px] text-[12px]">
                    {purchaseMode === "With Tax" &&
                    createItemValidations &&
                    (gstRate == "" || gstRate.length == 0)
                      ? "The gst rate field is required"
                      : ""}
                  </p>
                </Col>
              ) : (
                ""
              )}

              <Col span={12} className="pr-4 mt-3 mb-3">
                <Typography className="text-[#667085] expense-label mb-1">
                  ITC Applicable
                </Typography>
                <Select
                  placeholder="Select"
                  className="h-[40px] w-[100%]"
                  value={itcApplicable}
                  onChange={(e) => setItcApplicable(e)}
                  options={recordsMetaData ? recordsMetaData.itcOptions : []}
                />
              </Col>
            </Row>
          </Col>

          <Divider
            style={{
              borderWidth: "0.2px",
              width: "109%",
              marginLeft: "-24px",
            }}
          />
        </Modal>

        {/* <CreateItems modalOpen={createItemModal} modalClose={handleClose} /> */}
      </Row>

      <Modal
        open={pageRouting}
        onOk={() => {
          setPageRouting(false);
          history.push("/expenses");
        }}
        closeIcon
        maskClosable={false}
        rootClassName="p-15 h-[300px]"
        okText={"Yes, Leave"}
        cancelText={"No, Stay"}
        onCancel={() => setPageRouting(false)}
        footer={(_, { OkBtn, CancelBtn }) => (
          <div className="text-center flex justify-center">
            <div className="mr-3">
              <OkBtn />
            </div>
            <CancelBtn />
          </div>
        )}
        width={500}
      >
        <div
          style={{
            fontFamily: "Poppins",
          }}
          className="text-center w-[100%]"
        >
          <ExclamationCircleOutlined className="mb-2 text-center text-[#f1c40f] font-bold text-[44px]" />
          <h1 className="text-center text-[18px] font-bold">
            Are you sure you want to leave this page?
          </h1>
          <p className="text-center text-[14px] mt-2">
            All unsaved changes will be lost!
          </p>
        </div>
      </Modal>

      {/* <Prompt
        when={!isEmpty(expenseData.invoiceNumber)}
        message="Are you sure you want to leave?"
      /> */}
      <ToastContainer
        position="top-right"
        autoClose={3000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        // pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="dark"
        style={{
          fontSize: "12px",
          fontFamily: "Poppins",
        }}
      />
    </React.Fragment>
  );
};

CreateExpenses.propTypes = {
  location: PropTypes.any,
};

export default CreateExpenses;
